(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8503],{

/***/ 98229:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/swap",
      function () {
        return __webpack_require__(95829);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 83024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M12 6V7.79C12 8.24 12.54 8.46 12.85 8.14L15.64 5.35C15.84 5.15 15.84 4.84 15.64 4.64L12.85 1.85C12.54 1.54 12 1.76 12 2.21V4C7.58 4 4 7.58 4 12C4 13.04 4.2 14.04 4.57 14.95C4.84 15.62 5.7 15.8 6.21 15.29C6.48 15.02 6.59 14.61 6.44 14.25C6.15 13.56 6 12.79 6 12C6 8.69 8.69 6 12 6ZM17.79 8.71C17.52 8.98 17.41 9.4 17.56 9.75C17.84 10.45 18 11.21 18 12C18 15.31 15.31 18 12 18V16.21C12 15.76 11.46 15.54 11.15 15.86L8.36 18.65C8.16 18.85 8.16 19.16 8.36 19.36L11.15 22.15C11.46 22.46 12 22.24 12 21.8V20C16.42 20 20 16.42 20 12C20 10.96 19.8 9.96 19.43 9.05C19.16 8.38 18.3 8.2 17.79 8.71Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 90563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24802);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 310 10",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M133.384 3.16016H5.92847V4.21763H133.384V3.16016Z",
                fill: "#494949"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.92841 3.68986C5.92841 5.0117 4.83201 6.06917 3.46152 6.06917C2.09102 6.06917 0.994629 5.0117 0.994629 3.68986C0.994629 2.36802 2.09102 1.31055 3.46152 1.31055C4.83201 1.31055 5.92841 2.36802 5.92841 3.68986Z",
                fill: "#494949"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M304.961 3.6879C304.961 2.36607 306.057 1.30859 307.428 1.30859C308.798 1.30859 309.895 2.36607 309.895 3.6879C309.895 5.00974 308.798 6.06721 307.428 6.06721C306.057 6.06721 304.961 5.00974 304.961 3.6879Z",
                fill: "#494949"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M304.961 3.16016H177.505V4.21763H304.961V3.16016Z",
                fill: "#494949"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "none",
                d: "M164.082 1.05664L154.582 9.05664L145.082 1.05664",
                stroke: "#494949",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 46882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UnsupportedCurrencyFooter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86876);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(74566);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(199);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(62255);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(45388);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68486);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19521);
/* harmony import */ var components_Layout_Row__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30445);
/* harmony import */ var components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(941);
/* harmony import */ var components_Logo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19259);
/* harmony import */ var hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97477);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97119);
/* harmony import */ var utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(73938);
/* harmony import */ var _hooks_Tokens__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(41166);


function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 8px 0;\n  width: 100%;\n  max-width: 400px;\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  color: ",
        ";\n  background-color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var DetailsFooter = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-99e78957-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.invertedContrast;
});
var UnsupportedModal = function(param) {
    var currencies = param.currencies, onDismiss = param.onDismiss;
    var chainId = (0,hooks_useActiveWeb3React__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().chainId;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var tokens = chainId && currencies ? currencies.map(function(currency) {
        return (0,utils_wrappedCurrency__WEBPACK_IMPORTED_MODULE_8__/* .wrappedCurrency */ .pu)(currency, chainId);
    }) : [];
    var unsupportedTokens = (0,_hooks_Tokens__WEBPACK_IMPORTED_MODULE_9__/* .useUnsupportedTokens */ .l6)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
        title: t("Unsupported Assets"),
        onDismiss: onDismiss,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
            gap: "lg",
            children: [
                tokens.map(function(token) {
                    var ref;
                    return token && unsupportedTokens && Object.keys(unsupportedTokens).includes(token.address) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
                        gap: "10px",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(components_Layout_Row__WEBPACK_IMPORTED_MODULE_3__/* .AutoRow */ .BA, {
                                gap: "5px",
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Logo__WEBPACK_IMPORTED_MODULE_5__/* .CurrencyLogo */ .Xw, {
                                        currency: token,
                                        size: "24px"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        children: token.symbol
                                    })
                                ]
                            }),
                            chainId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                external: true,
                                small: true,
                                color: "primaryDark",
                                href: (0,utils__WEBPACK_IMPORTED_MODULE_7__/* .getBlockExploreLink */ .C)(token.address, "address", chainId),
                                children: token.address
                            })
                        ]
                    }, (ref = token.address) === null || ref === void 0 ? void 0 : ref.concat("not-supported"));
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Layout_Column__WEBPACK_IMPORTED_MODULE_4__/* .AutoColumn */ .Tz, {
                    gap: "lg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        children: t("Some assets are not available through this interface because they may not work well with our smart contract or we are unable to allow trading for legal reasons.")
                    })
                })
            ]
        })
    });
};
function UnsupportedCurrencyFooter(param) {
    var currencies = param.currencies;
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(UnsupportedModal, {
        currencies: currencies
    })), 1), onPresentModal = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DetailsFooter, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
            variant: "text",
            onClick: onPresentModal,
            children: t("Read more about unsupported assets")
        })
    });
}


/***/ }),

/***/ 95829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ swap; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/config/constants/supportChains.ts
var supportChains = __webpack_require__(80692);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/swap-sdk/src/index.ts + 21 modules
var src = __webpack_require__(1505);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(78258);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(29439);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(6538);
// EXTERNAL MODULE: ./src/components/Menu/Footer.tsx
var Footer = __webpack_require__(74156);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(97477);
// EXTERNAL MODULE: ./src/config/constants/index.ts
var constants = __webpack_require__(42918);
// EXTERNAL MODULE: ./src/config/constants/exchange.ts
var exchange = __webpack_require__(56974);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/state/index.ts + 32 modules
var state = __webpack_require__(106);
// EXTERNAL MODULE: ./src/state/limitOrders/actions.ts
var actions = __webpack_require__(47330);
// EXTERNAL MODULE: ./src/state/limitOrders/types.ts
var types = __webpack_require__(91392);
;// CONCATENATED MODULE: ./src/state/limitOrders/hooks.ts









function parseTokenAmountURLParameter(urlParam) {
    return typeof urlParam === "string" && !Number.isNaN(parseFloat(urlParam)) ? urlParam : "";
}
function parseIndependentFieldURLParameter(urlParam) {
    return typeof urlParam === "string" && urlParam.toLowerCase() === "output" ? types/* Field.OUTPUT */.g.OUTPUT : types/* Field.INPUT */.g.INPUT;
}
function parseCurrencyFromURLParameter(urlParam) {
    if (typeof urlParam === "string") {
        var valid = (0,utils/* isAddress */.UJ)(urlParam);
        if (valid) return valid;
        if (urlParam.toUpperCase() === "BNB") return "BNB";
        if (valid === false) return "BNB";
    }
    return "";
}
// TODO: combine with swap's version but use generic type. Same for helpers above
// Note: swap has recipient and other things. Merging these 2 would probably be much easier if we get rid of recipient
// Also the whole thing doesn't make sense, in swap inputValue is not initialized but typedValue is. WTF
var queryParametersToSwapState = function(parsedQs) {
    var inputCurrency = parseCurrencyFromURLParameter(parsedQs.inputCurrency) || exchange/* DEFAULT_INPUT_CURRENCY */.VN;
    var outputCurrency = parseCurrencyFromURLParameter(parsedQs.outputCurrency) || exchange/* DEFAULT_OUTPUT_CURRENCY */.g$;
    if (inputCurrency === outputCurrency) {
        if (typeof parsedQs.outputCurrency === "string") {
            inputCurrency = "";
        } else {
            outputCurrency = "";
        }
    }
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, types/* Field.INPUT */.g.INPUT, {
        currencyId: inputCurrency
    }), (0,_define_property/* default */.Z)(_obj, types/* Field.OUTPUT */.g.OUTPUT, {
        currencyId: outputCurrency
    }), (0,_define_property/* default */.Z)(_obj, "inputValue", ""), (0,_define_property/* default */.Z)(_obj, "outputValue", ""), (0,_define_property/* default */.Z)(_obj, "typedValue", parseTokenAmountURLParameter(parsedQs.exactAmount)), (0,_define_property/* default */.Z)(_obj, "independentField", parseIndependentFieldURLParameter(parsedQs.exactField)), (0,_define_property/* default */.Z)(_obj, "basisField", parseIndependentFieldURLParameter(parsedQs.exactField)), (0,_define_property/* default */.Z)(_obj, "rateType", types/* Rate.MUL */.j.MUL), _obj;
};
// updates the swap state to use the defaults for a given network
var useDefaultsFromURLSearch = function() {
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var dispatch = (0,state/* useAppDispatch */.TL)();
    var query = (0,next_router.useRouter)().query;
    var ref = (0,react.useState)(), result = ref[0], setResult = ref[1];
    (0,react.useEffect)(function() {
        if (!chainId) return;
        var parsed = queryParametersToSwapState(query);
        dispatch((0,actions/* replaceLimitOrdersState */.sQ)(parsed));
        setResult({
            inputCurrencyId: parsed[types/* Field.INPUT */.g.INPUT].currencyId,
            outputCurrencyId: parsed[types/* Field.OUTPUT */.g.OUTPUT].currencyId
        });
    }, [
        dispatch,
        chainId,
        query
    ]);
    return result;
};

// EXTERNAL MODULE: ./src/components/Layout/PageFullWidth.tsx
var PageFullWidth = __webpack_require__(38047);
// EXTERNAL MODULE: ./src/components/Menu/SubNav.tsx
var SubNav = __webpack_require__(21281);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 1 modules
var localization_src = __webpack_require__(68486);
// EXTERNAL MODULE: ./src/hooks/Tokens.ts
var Tokens = __webpack_require__(41166);
// EXTERNAL MODULE: ./src/state/swap/actions.ts
var swap_actions = __webpack_require__(15103);
// EXTERNAL MODULE: ./src/state/swap/hooks.ts + 40 modules
var hooks = __webpack_require__(25840);
// EXTERNAL MODULE: ./src/state/user/hooks/index.tsx
var user_hooks = __webpack_require__(921);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(74566);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(66354);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/SwapIcon.tsx
var SwapIcon = __webpack_require__(90563);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(45388);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(93233);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(55604);
// EXTERNAL MODULE: ./packages/uikit/src/components/Message/Message.tsx + 1 modules
var Message = __webpack_require__(67405);
// EXTERNAL MODULE: ./src/hooks/Trades.ts + 1 modules
var Trades = __webpack_require__(94293);
// EXTERNAL MODULE: ./src/components/UnsupportedCurrencyFooter.tsx
var UnsupportedCurrencyFooter = __webpack_require__(46882);
// EXTERNAL MODULE: ./src/utils/maxAmountSpend.ts
var maxAmountSpend = __webpack_require__(11372);
// EXTERNAL MODULE: ./src/state/swap/useSwapActionHandlers.ts
var useSwapActionHandlers = __webpack_require__(1999);
// EXTERNAL MODULE: ./src/components/CurrencyInputPanel/index.tsx + 1 modules
var CurrencyInputPanel = __webpack_require__(53258);
// EXTERNAL MODULE: ./src/components/SearchModal/types.ts
var SearchModal_types = __webpack_require__(93156);
// EXTERNAL MODULE: ./src/components/Layout/Row.tsx
var Row = __webpack_require__(30445);
// EXTERNAL MODULE: ./src/components/Layout/Column.tsx
var Column = __webpack_require__(941);
// EXTERNAL MODULE: ./src/hooks/useApproveCallback.ts + 2 modules
var useApproveCallback = __webpack_require__(36585);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./packages/utils/tryParseAmount.ts
var tryParseAmount = __webpack_require__(68492);
// EXTERNAL MODULE: ./src/state/transactions/hooks.tsx
var transactions_hooks = __webpack_require__(56906);
// EXTERNAL MODULE: ./src/state/wallet/hooks.ts
var wallet_hooks = __webpack_require__(5460);
// EXTERNAL MODULE: ./src/hooks/useContract.ts + 13 modules
var useContract = __webpack_require__(80070);
// EXTERNAL MODULE: ./src/hooks/useCallWithMarketGasPrice.ts
var useCallWithMarketGasPrice = __webpack_require__(31063);
;// CONCATENATED MODULE: ./src/hooks/useWrapCallback.ts











var WrapType;
(function(WrapType) {
    WrapType[WrapType["NOT_APPLICABLE"] = 0] = "NOT_APPLICABLE";
    WrapType[WrapType["WRAP"] = 1] = "WRAP";
    WrapType[WrapType["UNWRAP"] = 2] = "UNWRAP";
})(WrapType || (WrapType = {}));
var NOT_APPLICABLE = {
    wrapType: WrapType.NOT_APPLICABLE
};
/**
 * Given the selected input and output currency, return a wrap callback
 * @param inputCurrency the selected input currency
 * @param outputCurrency the selected output currency
 * @param typedValue the user input value
 */ function useWrapCallback(inputCurrency, outputCurrency, typedValue) {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,useActiveWeb3React/* default */.Z)(), chainId = ref.chainId, account = ref.account;
    var callWithMarketGasPrice = (0,useCallWithMarketGasPrice/* useCallWithMarketGasPrice */.r)().callWithMarketGasPrice;
    var wbnbContract = (0,useContract/* useWNativeContract */.vR)();
    var balance = (0,wallet_hooks/* useCurrencyBalance */._h)(account !== null && account !== void 0 ? account : undefined, inputCurrency);
    // we can always parse the amount typed as the input currency, since wrapping is 1:1
    var inputAmount = (0,react.useMemo)(function() {
        return (0,tryParseAmount/* default */.Z)(typedValue, inputCurrency);
    }, [
        inputCurrency,
        typedValue
    ]);
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    return (0,react.useMemo)(function() {
        var ref, ref1;
        if (!wbnbContract || !chainId || !inputCurrency || !outputCurrency) return NOT_APPLICABLE;
        var sufficientBalance = inputAmount && balance && !balance.lessThan(inputAmount);
        if ((inputCurrency === null || inputCurrency === void 0 ? void 0 : inputCurrency.isNative) && ((ref = src/* WNATIVE */.FX[chainId]) === null || ref === void 0 ? void 0 : ref.equals(outputCurrency))) {
            return {
                wrapType: WrapType.WRAP,
                execute: sufficientBalance && inputAmount ? /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var txReceipt, amount, native, wrap, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    callWithMarketGasPrice(wbnbContract, "deposit", undefined, {
                                        value: "0x".concat(inputAmount.quotient.toString(16))
                                    })
                                ];
                            case 1:
                                txReceipt = _state.sent();
                                amount = inputAmount.toSignificant(6);
                                native = inputCurrency.symbol;
                                wrap = src/* WNATIVE */.FX[chainId].symbol;
                                addTransaction(txReceipt, {
                                    summary: "Wrap ".concat(amount, " ").concat(native, " to ").concat(wrap),
                                    translatableSummary: {
                                        text: "Wrap %amount% %native% to %wrap%",
                                        data: {
                                            amount: amount,
                                            native: native,
                                            wrap: wrap
                                        }
                                    },
                                    type: "wrap"
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                console.error("Could not deposit", error);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }) : undefined,
                inputError: sufficientBalance ? undefined : t("Insufficient %symbol% balance", {
                    symbol: inputCurrency.symbol
                })
            };
        }
        if (((ref1 = src/* WNATIVE */.FX[chainId]) === null || ref1 === void 0 ? void 0 : ref1.equals(inputCurrency)) && (outputCurrency === null || outputCurrency === void 0 ? void 0 : outputCurrency.isNative)) {
            return {
                wrapType: WrapType.UNWRAP,
                execute: sufficientBalance && inputAmount ? /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                    var txReceipt, amount, wrap, native, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    callWithMarketGasPrice(wbnbContract, "withdraw", [
                                        "0x".concat(inputAmount.quotient.toString(16))
                                    ])
                                ];
                            case 1:
                                txReceipt = _state.sent();
                                amount = inputAmount.toSignificant(6);
                                wrap = src/* WNATIVE */.FX[chainId].symbol;
                                native = outputCurrency.symbol;
                                addTransaction(txReceipt, {
                                    summary: "Unwrap ".concat(amount, " ").concat(wrap, " to ").concat(native),
                                    translatableSummary: {
                                        text: "Unwrap %amount% %wrap% to %native%",
                                        data: {
                                            amount: amount,
                                            wrap: wrap,
                                            native: native
                                        }
                                    }
                                });
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                console.error("Could not withdraw", error);
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                }) : undefined,
                inputError: sufficientBalance ? undefined : t("Insufficient %symbol% balance", {
                    symbol: inputCurrency.symbol
                })
            };
        }
        return NOT_APPLICABLE;
    }, [
        wbnbContract,
        chainId,
        inputCurrency,
        outputCurrency,
        t,
        inputAmount,
        balance,
        addTransaction,
        callWithMarketGasPrice, 
    ]);
}

// EXTERNAL MODULE: ./packages/utils/replaceBrowserHistory.ts
var replaceBrowserHistory = __webpack_require__(36399);
// EXTERNAL MODULE: ./src/utils/currencyId.ts
var currencyId = __webpack_require__(29159);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(62255);
// EXTERNAL MODULE: ./src/components/CommitButton.tsx
var CommitButton = __webpack_require__(52036);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(7447);
// EXTERNAL MODULE: ./src/components/Loader/CircleLoader.tsx
var CircleLoader = __webpack_require__(83743);
// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/SettingsModal.tsx + 2 modules
var SettingsModal = __webpack_require__(24673);
// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/types.ts
var GlobalSettings_types = __webpack_require__(47756);
// EXTERNAL MODULE: ./src/utils/exchange.ts + 1 modules
var utils_exchange = __webpack_require__(17937);
// EXTERNAL MODULE: ./src/hooks/useTransactionDeadline.ts + 1 modules
var useTransactionDeadline = __webpack_require__(25490);
;// CONCATENATED MODULE: ./src/hooks/useSwapCallArguments.ts







/**
 * Returns the swap calls that can be used to make the trade
 * @param trade trade to execute
 * @param allowedSlippage user allowed slippage
 * @param recipientAddressOrName
 */ function useSwapCallArguments(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : constants/* INITIAL_ALLOWED_SLIPPAGE */.gv, recipientAddress = arguments.length > 2 ? arguments[2] : void 0;
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var recipient = recipientAddress === null ? account : recipientAddress;
    var deadline = (0,useTransactionDeadline/* default */.Z)();
    var contract = (0,utils_exchange/* useRouterContract */.Ti)();
    return (0,react.useMemo)(function() {
        if (!trade || !recipient || !account || !chainId || !deadline) return [];
        if (!contract) {
            return [];
        }
        var swapMethods = [];
        swapMethods.push(src/* Router.swapCallParameters */.F0.swapCallParameters(trade, {
            feeOnTransfer: false,
            allowedSlippage: new src/* Percent */.gG(src/* JSBI.BigInt */.QA.BigInt(allowedSlippage), exchange/* BIPS_BASE */.PM),
            recipient: recipient,
            deadline: deadline.toNumber()
        }));
        if (trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT) {
            swapMethods.push(src/* Router.swapCallParameters */.F0.swapCallParameters(trade, {
                feeOnTransfer: true,
                allowedSlippage: new src/* Percent */.gG(src/* JSBI.BigInt */.QA.BigInt(allowedSlippage), exchange/* BIPS_BASE */.PM),
                recipient: recipient,
                deadline: deadline.toNumber()
            }));
        }
        return swapMethods.map(function(parameters) {
            return {
                parameters: parameters,
                contract: contract
            };
        });
    }, [
        account,
        allowedSlippage,
        chainId,
        contract,
        deadline,
        recipient,
        trade
    ]);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
;// CONCATENATED MODULE: ./packages/utils/isZero.ts
/**
 * Returns true if the string value is zero in hex
 * @param hexNumberString
 */ function isZero(hexNumberString) {
    return /^0x0*$/.test(hexNumberString);
}

// EXTERNAL MODULE: ./packages/utils/truncateHash.ts
var truncateHash = __webpack_require__(15260);
// EXTERNAL MODULE: ./src/utils/transactionErrorToUserReadableMessage.ts
var transactionErrorToUserReadableMessage = __webpack_require__(78809);
;// CONCATENATED MODULE: ./src/hooks/useSwapCallback.ts















var SwapCallbackState;
(function(SwapCallbackState) {
    SwapCallbackState[SwapCallbackState["INVALID"] = 0] = "INVALID";
    SwapCallbackState[SwapCallbackState["LOADING"] = 1] = "LOADING";
    SwapCallbackState[SwapCallbackState["VALID"] = 2] = "VALID";
})(SwapCallbackState || (SwapCallbackState = {}));
// returns a function that will execute a swap, if the parameters are all valid
// and the user has approved the slippage adjusted input amount for the trade
function useSwapCallback(trade) {
    var allowedSlippage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : constants/* INITIAL_ALLOWED_SLIPPAGE */.gv, recipientAddress = arguments.length > 2 ? arguments[2] : void 0, swapCalls = arguments.length > 3 ? arguments[3] : void 0;
    var ref = (0,useActiveWeb3React/* default */.Z)(), account = ref.account, chainId = ref.chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var addTransaction = (0,transactions_hooks/* useTransactionAdder */.h7)();
    var recipient = recipientAddress === null ? account : recipientAddress;
    return (0,react.useMemo)(function() {
        if (!trade || !account || !chainId) {
            return {
                state: SwapCallbackState.INVALID,
                callback: null,
                error: "Missing dependencies"
            };
        }
        if (!recipient) {
            if (recipientAddress !== null) {
                return {
                    state: SwapCallbackState.INVALID,
                    callback: null,
                    error: "Invalid recipient"
                };
            }
            return {
                state: SwapCallbackState.LOADING,
                callback: null,
                error: null
            };
        }
        return {
            state: SwapCallbackState.VALID,
            callback: function() {
                var _onSwap = (0,_async_to_generator/* default */.Z)(function() {
                    var _contract, estimatedCalls, successfulEstimation, errorCalls, _call, contract, _parameters, methodName, args, value, gasEstimate;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    Promise.all(swapCalls.map(function(call) {
                                        var _estimateGas;
                                        var _parameters = call.parameters, methodName = _parameters.methodName, args = _parameters.args, value = _parameters.value, contract = call.contract;
                                        var options = !value || isZero(value) ? {} : {
                                            value: value
                                        };
                                        return (_estimateGas = contract.estimateGas)[methodName].apply(_estimateGas, (0,_to_consumable_array/* default */.Z)(args).concat([
                                            options
                                        ])).then(function(gasEstimate) {
                                            return {
                                                call: call,
                                                gasEstimate: gasEstimate
                                            };
                                        }).catch(function(gasError) {
                                            var _callStatic;
                                            console.error("Gas estimate failed, trying eth_call to extract error", call);
                                            return (_callStatic = contract.callStatic)[methodName].apply(_callStatic, (0,_to_consumable_array/* default */.Z)(args).concat([
                                                options
                                            ])).then(function(result) {
                                                console.error("Unexpected successful call after failed estimate gas", call, gasError, result);
                                                return {
                                                    call: call,
                                                    error: t("Unexpected issue with estimating the gas. Please try again.")
                                                };
                                            }).catch(function(callError) {
                                                console.error("Call threw error", call, callError);
                                                return {
                                                    call: call,
                                                    error: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(callError, t)
                                                };
                                            });
                                        });
                                    }))
                                ];
                            case 1:
                                estimatedCalls = _state.sent();
                                successfulEstimation = estimatedCalls.find(function(el, ix, list) {
                                    return "gasEstimate" in el && (ix === list.length - 1 || "gasEstimate" in list[ix + 1]);
                                });
                                if (!successfulEstimation) {
                                    errorCalls = estimatedCalls.filter(function(call) {
                                        return "error" in call;
                                    });
                                    if (errorCalls.length > 0) throw new Error(errorCalls[errorCalls.length - 1].error);
                                    throw new Error(t("Unexpected error. Could not estimate gas for the swap."));
                                }
                                _call = successfulEstimation.call, contract = _call.contract, _parameters = _call.parameters, methodName = _parameters.methodName, args = _parameters.args, value = _parameters.value, gasEstimate = successfulEstimation.gasEstimate;
                                return [
                                    2,
                                    (_contract = contract)[methodName].apply(_contract, (0,_to_consumable_array/* default */.Z)(args).concat([
                                        (0,_object_spread/* default */.Z)({
                                            gasLimit: (0,utils/* calculateGasMargin */.yC)(gasEstimate)
                                        }, value && !isZero(value) ? {
                                            value: value,
                                            from: account
                                        } : {
                                            from: account
                                        })
                                    ])).then(function(response) {
                                        var inputSymbol = trade.inputAmount.currency.symbol;
                                        var outputSymbol = trade.outputAmount.currency.symbol;
                                        var pct = (0,utils_exchange/* basisPointsToPercent */.P4)(allowedSlippage);
                                        var inputAmount = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.inputAmount.toSignificant(3) : trade.maximumAmountIn(pct).toSignificant(3);
                                        var outputAmount = trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT ? trade.outputAmount.toSignificant(3) : trade.minimumAmountOut(pct).toSignificant(3);
                                        var base = "Swap ".concat(trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT ? "max." : "", " ").concat(inputAmount, " ").concat(inputSymbol, " for ").concat(trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? "min." : "", " ").concat(outputAmount, " ").concat(outputSymbol);
                                        var recipientAddressText = recipientAddress && (0,utils/* isAddress */.UJ)(recipientAddress) ? (0,truncateHash/* default */.Z)(recipientAddress) : recipientAddress;
                                        var withRecipient = recipient === account ? base : "".concat(base, " to ").concat(recipientAddressText);
                                        var translatableWithRecipient = trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT ? recipient === account ? "Swap max. %inputAmount% %inputSymbol% for %outputAmount% %outputSymbol%" : "Swap max. %inputAmount% %inputSymbol% for %outputAmount% %outputSymbol% to %recipientAddress%" : recipient === account ? "Swap %inputAmount% %inputSymbol% for min. %outputAmount% %outputSymbol%" : "Swap %inputAmount% %inputSymbol% for min. %outputAmount% %outputSymbol% to %recipientAddress%";
                                        addTransaction(response, {
                                            summary: withRecipient,
                                            translatableSummary: {
                                                text: translatableWithRecipient,
                                                data: (0,_object_spread/* default */.Z)({
                                                    inputAmount: inputAmount,
                                                    inputSymbol: inputSymbol,
                                                    outputAmount: outputAmount,
                                                    outputSymbol: outputSymbol
                                                }, recipient !== account && {
                                                    recipientAddress: recipientAddressText
                                                })
                                            },
                                            type: "swap"
                                        });
                                        return response.hash;
                                    }).catch(function(error) {
                                        // if the user rejected the tx, pass this along
                                        if ((error === null || error === void 0 ? void 0 : error.code) === 4001) {
                                            throw new Error("Transaction rejected.");
                                        } else {
                                            // otherwise, the error was unexpected and we need to convey that
                                            console.error("Swap failed", error, methodName, args, value);
                                            throw new Error(t("Swap failed: %message%", {
                                                message: (0,transactionErrorToUserReadableMessage/* transactionErrorToUserReadableMessage */.e)(error, t)
                                            }));
                                        }
                                    })
                                ];
                        }
                    });
                });
                function onSwap() {
                    return _onSwap.apply(this, arguments);
                }
                return onSwap;
            }(),
            error: null
        };
    }, [
        trade,
        account,
        chainId,
        recipient,
        recipientAddress,
        swapCalls,
        t,
        addTransaction,
        allowedSlippage
    ]);
}

;// CONCATENATED MODULE: ./src/views/Swap/components/confirmPriceImpactWithoutFee.ts

/**
 * Given the price impact, get user confirmation.
 *
 * @param priceImpactWithoutFee price impact of the trade without the fee.
 * @param t Translation
 */ function confirmPriceImpactWithoutFee(priceImpactWithoutFee, t) {
    if (!priceImpactWithoutFee.lessThan(exchange/* PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN */.EV)) {
        var confirmWord = "confirm";
        return(// eslint-disable-next-line no-alert
        window.prompt(t('This swap has a price impact of at least %amount%%. Please type the word "%word%" to continue with this swap.', {
            amount: exchange/* PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN.toFixed */.EV.toFixed(0),
            word: confirmWord
        })) === confirmWord);
    }
    if (!priceImpactWithoutFee.lessThan(exchange/* ALLOWED_PRICE_IMPACT_HIGH */.Uf)) {
        // eslint-disable-next-line no-alert
        return window.confirm(t("This swap has a price impact of at least %amount%%. Please confirm that you would like to continue with this swap.", {
            amount: exchange/* ALLOWED_PRICE_IMPACT_HIGH.toFixed */.Uf.toFixed(0)
        }));
    }
    return true;
}

// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(68304);
// EXTERNAL MODULE: ./src/components/TransactionConfirmationModal/index.tsx + 2 modules
var TransactionConfirmationModal = __webpack_require__(51931);
// EXTERNAL MODULE: ./packages/uikit/src/components/Spinner/Spinner.tsx + 3 modules
var Spinner = __webpack_require__(78585);
;// CONCATENATED MODULE: ./src/views/Swap/components/ConfirmationPendingContent.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9a2eeac-0"
})(_templateObject());
var ConfirmedIcon = (0,styled_components_browser_esm/* default */.ZP)(Column/* ColumnCenter */.lg).withConfig({
    componentId: "sc-b9a2eeac-1"
})(_templateObject1());
function ConfirmationPendingContent(param) {
    var trade = param.trade;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref6, ref7, ref8, ref9;
    // text to show while loading
    var pendingText = t("Swapping %amountA% %symbolA% for %amountB% %symbolB%", {
        amountA: (ref6 = trade === null || trade === void 0 ? void 0 : (ref = trade.inputAmount) === null || ref === void 0 ? void 0 : ref.toSignificant(6)) !== null && ref6 !== void 0 ? ref6 : "",
        symbolA: (ref7 = trade === null || trade === void 0 ? void 0 : (ref1 = trade.inputAmount) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.currency) === null || ref2 === void 0 ? void 0 : ref2.symbol) !== null && ref7 !== void 0 ? ref7 : "",
        amountB: (ref8 = trade === null || trade === void 0 ? void 0 : (ref3 = trade.outputAmount) === null || ref3 === void 0 ? void 0 : ref3.toSignificant(6)) !== null && ref8 !== void 0 ? ref8 : "",
        symbolB: (ref9 = trade === null || trade === void 0 ? void 0 : (ref4 = trade.outputAmount) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.currency) === null || ref5 === void 0 ? void 0 : ref5.symbol) !== null && ref9 !== void 0 ? ref9 : ""
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmedIcon, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                gap: "12px",
                justify: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "20px",
                        children: t("Waiting for confirmation")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                        gap: "12px",
                        justify: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            small: true,
                            textAlign: "center",
                            children: pendingText
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "center",
                        children: t("Confirm this transaction in your wallet")
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var components_ConfirmationPendingContent = (ConfirmationPendingContent);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(83024);
// EXTERNAL MODULE: ./src/components/QuestionHelper/index.tsx
var QuestionHelper = __webpack_require__(72566);
// EXTERNAL MODULE: ./src/config/constants/info.ts
var info = __webpack_require__(7269);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/Error.tsx
var Icons_Error = __webpack_require__(11658);
;// CONCATENATED MODULE: ./src/views/Swap/components/styleds.tsx

function styleds_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: relative;\n    padding: 2rem;\n    border-radius: 20px;\n    background:url('/images/pibridge/bg_form_exchange.png') 100% 100%;\n    background-size: 100% 100%;\n    background-repeat: no-repeat;\n    background-position: center top;\n    @media screen and (max-width: 600px) {\n      padding: 1rem 20px 2rem 14px;    \n      background:url('/images/pibridge/bg_form_exchange.png') 100% 100%;\n      background-size: 100% 100%;\n      background-repeat: no-repeat;\n      background-position: center top;\n    }\n"
    ]);
    styleds_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styleds_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          :hover {\n            cursor: pointer;\n            opacity: 0.8;\n          }\n        "
    ]);
    styleds_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 22px;\n  width: 22px;\n  background-color: ",
        ";\n  border: none;\n  border-radius: 50%;\n  padding: 0.2rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  margin-left: 0.4rem;\n  cursor: pointer;\n  color: ",
        ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  float: right;\n\n  :hover {\n    background-color: ",
        ";\n  }\n  :focus {\n    background-color: ",
        ";\n    outline: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 220px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 1rem;\n  display: flex;\n  align-items: center;\n  font-size: 0.825rem;\n  width: 100%;\n  padding: 3rem 1.25rem 1rem 1rem;\n  margin-top: -2rem;\n  color: ",
        ";\n  z-index: -1;\n  p {\n    padding: 0;\n    margin: 0;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 12px;\n  border-radius: 12px;\n  min-width: 48px;\n  height: 48px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  padding: 0.5rem;\n  border-radius: 12px;\n  margin-top: 8px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var styleds_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6be96888-0"
})(styleds_templateObject());
var ArrowWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6be96888-1"
})(_templateObject2(), function(param) {
    var clickable = param.clickable;
    return clickable ? (0,styled_components_browser_esm/* css */.iv)(styleds_templateObject1()) : null;
});
var ErrorText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-6be96888-2"
})(_templateObject3(), function(param) {
    var theme = param.theme, severity = param.severity;
    return severity === 3 || severity === 4 ? theme.colors.failure : severity === 2 ? theme.colors.warning : severity === 1 ? theme.colors.text : theme.colors.success;
});
var StyledBalanceMaxMini = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
    componentId: "sc-6be96888-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.colors.dropdown;
});
var TruncatedText = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    ellipsis: true
}).withConfig({
    componentId: "sc-6be96888-4"
})(_templateObject5());
var SwapCallbackErrorInner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6be96888-5"
})(_templateObject6(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.failure33);
}, function(param) {
    var theme = param.theme;
    return theme.colors.failure;
});
var SwapCallbackErrorInnerAlertTriangle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6be96888-6"
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.failure33);
});
function SwapCallbackError(param) {
    var error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwapCallbackErrorInner, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackErrorInnerAlertTriangle, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Error/* default */.Z, {
                    width: "24px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: error
            })
        ]
    });
}
var SwapShowAcceptChanges = (0,styled_components_browser_esm/* default */.ZP)(Column/* AutoColumn */.Tz).withConfig({
    componentId: "sc-6be96888-7"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return "".concat(theme.colors.warning43);
});

;// CONCATENATED MODULE: ./src/views/Swap/components/FormattedPriceImpact.tsx




/**
 * Formatted version of price impact text with warning colors
 */ function FormattedPriceImpact(param) {
    var priceImpact = param.priceImpact;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorText, {
        fontSize: "14px",
        severity: (0,utils_exchange/* warningSeverity */.oX)(priceImpact),
        children: priceImpact ? priceImpact.lessThan(exchange/* ONE_BIPS */.IS) ? "<0.01%" : "".concat(priceImpact.toFixed(2), "%") : "-"
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapModalFooter.tsx

function SwapModalFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 24px 0 24px;\n  padding: 16px;\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  background-color: transparent;\n"
    ]);
    SwapModalFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var SwapModalFooterContainer = (0,styled_components_browser_esm/* default */.ZP)(Column/* AutoColumn */.Tz).withConfig({
    componentId: "sc-dd4eb63a-0"
})(SwapModalFooter_templateObject(), function(param) {
    var theme = param.theme;
    return theme.radii.default;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
function SwapModalFooter(param) {
    var trade = param.trade, slippageAdjustedAmounts = param.slippageAdjustedAmounts, isEnoughInputBalance = param.isEnoughInputBalance, onConfirm = param.onConfirm, swapErrorMessage = param.swapErrorMessage, disabledConfirm = param.disabledConfirm;
    var ref, ref1;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref2 = (0,react.useState)(false), showInverted = ref2[0], setShowInverted = ref2[1];
    var ref3 = (0,react.useMemo)(function() {
        return (0,utils_exchange/* computeTradePriceBreakdown */.U7)(trade);
    }, [
        trade
    ]), priceImpactWithoutFee = ref3.priceImpactWithoutFee, realizedLPFee = ref3.realizedLPFee;
    var severity = (0,utils_exchange/* warningSeverity */.oX)(priceImpactWithoutFee);
    var totalFeePercent = "".concat((info/* TOTAL_FEE */.om * 100).toFixed(2), "%");
    var lpHoldersFeePercent = "".concat((info/* LP_HOLDERS_FEE */.BY * 100).toFixed(2), "%");
    var treasuryFeePercent = "".concat((info/* TREASURY_FEE */.hT * 100).toFixed(4), "%");
    var buyBackFeePercent = "".concat((info/* BUYBACK_FEE */.xy * 100).toFixed(4), "%");
    var ref4, ref5;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SwapModalFooterContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                children: t("Price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "14px",
                                style: {
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    textAlign: "right",
                                    paddingLeft: "10px"
                                },
                                children: [
                                    (0,utils_exchange/* formatExecutionPrice */.Kh)(trade, showInverted),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceMaxMini, {
                                        onClick: function() {
                                            return setShowInverted(!showInverted);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                            width: "14px"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? t("Minimum received") : t("Maximum sold")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                        text: t("Your transaction will revert if there is a large, unfavorable price movement before it is confirmed."),
                                        ml: "4px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? (ref4 = (ref = slippageAdjustedAmounts[swap_actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(4)) !== null && ref4 !== void 0 ? ref4 : "-" : (ref5 = (ref1 = slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(4)) !== null && ref5 !== void 0 ? ref5 : "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        marginLeft: "4px",
                                        children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.outputAmount.currency.symbol : trade.inputAmount.currency.symbol
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: t("Price impact")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                        text: t("The difference between the market price and your price due to trade size."),
                                        ml: "4px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormattedPriceImpact, {
                                priceImpact: priceImpactWithoutFee
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: t("Liquidity provider fee")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                        text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                    mb: "12px",
                                                    children: t("For each trade a %amount% fee is paid", {
                                                        amount: totalFeePercent
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    children: [
                                                        "- ",
                                                        t("%amount% to LP token holders", {
                                                            amount: lpHoldersFeePercent
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    children: [
                                                        "- ",
                                                        t("%amount% to the Treasury", {
                                                            amount: treasuryFeePercent
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                    children: [
                                                        "- ",
                                                        t("%amount% towards CAKE buyback and burn", {
                                                            amount: buyBackFeePercent
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        ml: "4px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                children: realizedLPFee ? "".concat(realizedLPFee === null || realizedLPFee === void 0 ? void 0 : realizedLPFee.toSignificant(6), " ").concat(trade.inputAmount.currency.symbol) : "-"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                style: {
                    display: "flex",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        // variant={severity > 2 ? 'danger' : 'primary'}
                        onClick: onConfirm,
                        disabled: disabledConfirm,
                        mt: "12px",
                        id: "confirm-swap-or-send",
                        width: "80%",
                        children: severity > 2 || trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && !isEnoughInputBalance ? t("Swap anyway") : t("Confirm swap")
                    }),
                    swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackError, {
                        error: swapErrorMessage
                    }) : null
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/Logo/index.ts + 2 modules
var Logo = __webpack_require__(19259);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapModalHeader.tsx













function SwapModalHeader(param) {
    var trade = param.trade, slippageAdjustedAmounts = param.slippageAdjustedAmounts, isEnoughInputBalance = param.isEnoughInputBalance, recipient = param.recipient, showAcceptChanges = param.showAcceptChanges, onAcceptChanges = param.onAcceptChanges, allowedSlippage = param.allowedSlippage;
    var ref, ref1;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var priceImpactWithoutFee = (0,react.useMemo)(function() {
        return (0,utils_exchange/* computeTradePriceBreakdown */.U7)(trade);
    }, [
        trade
    ]).priceImpactWithoutFee;
    var priceImpactSeverity = (0,utils_exchange/* warningSeverity */.oX)(priceImpactWithoutFee);
    var inputTextColor = showAcceptChanges && trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && isEnoughInputBalance ? "primary" : trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && !isEnoughInputBalance ? "text" : "text";
    var amount = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? (ref = slippageAdjustedAmounts[swap_actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(6) : (ref1 = slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6);
    var symbol = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.outputAmount.currency.symbol : trade.inputAmount.currency.symbol;
    var tradeInfoText = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? t("Output is estimated. You will receive at least or the transaction will revert.") : t("Input is estimated. You will sell at most or the transaction will revert.");
    var ref2 = (0,_sliced_to_array/* default */.Z)(tradeInfoText.split("".concat(amount, " ").concat(symbol)), 2), estimatedText = ref2[0], transactionRevertText = ref2[1];
    var truncatedRecipient = recipient ? (0,truncateHash/* default */.Z)(recipient) : "";
    var recipientInfoText = t("Output will be sent to %recipient%", {
        recipient: truncatedRecipient
    });
    var ref3 = (0,_sliced_to_array/* default */.Z)(recipientInfoText.split(truncatedRecipient), 2), recipientSentToText = ref3[0], postSentToText = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        gap: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        gap: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                currency: trade.inputAmount.currency,
                                size: "24px",
                                style: {
                                    marginRight: "12px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedText, {
                                fontSize: "24px",
                                color: inputTextColor,
                                children: trade.inputAmount.toSignificant(6)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                        gap: "0px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "24px",
                            ml: "10px",
                            children: trade.inputAmount.currency.symbol
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                    width: "16px",
                    ml: "4px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        gap: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                currency: trade.outputAmount.currency,
                                size: "24px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedText, {
                                fontSize: "24px",
                                color: priceImpactSeverity > 2 ? "text" : showAcceptChanges && trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? "primary" : "text",
                                children: trade.outputAmount.toSignificant(6)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "24px",
                            ml: "10px",
                            children: trade.outputAmount.currency.symbol
                        })
                    })
                ]
            }),
            showAcceptChanges ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapShowAcceptChanges, {
                justify: "flex-start",
                gap: "0px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Error/* default */.Z, {
                                    mr: "8px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    bold: true,
                                    children: [
                                        " ",
                                        t("Price Updated")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: onAcceptChanges,
                            children: t("Accept")
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                justify: "flex-start",
                gap: "sm",
                style: {
                    padding: "24px 0 0 0px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        style: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "text",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Slippage Tolerance")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                color: "#000",
                                ml: "auto",
                                textAlign: "end",
                                children: "".concat(allowedSlippage / 100, "%")
                            })
                        ]
                    }),
                    trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && !isEnoughInputBalance && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        small: true,
                        color: "failure",
                        textAlign: "left",
                        style: {
                            width: "100%"
                        },
                        children: t("Insufficient input token balance. Your transaction may fail.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "left",
                        style: {
                            width: "100%"
                        },
                        children: [
                            estimatedText,
                            transactionRevertText
                        ]
                    })
                ]
            }),
            recipient !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                justify: "flex-start",
                gap: "sm",
                style: {
                    padding: "12px 0 0 0px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    color: "textSubtle",
                    children: [
                        recipientSentToText,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            title: recipient,
                            children: truncatedRecipient
                        }),
                        postSentToText
                    ]
                })
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/StableSwap/components/StableSwapModalHeader.tsx












function StableSwapModalHeader(param) {
    var trade = param.trade, slippageAdjustedAmounts = param.slippageAdjustedAmounts, isEnoughInputBalance = param.isEnoughInputBalance, recipient = param.recipient, showAcceptChanges = param.showAcceptChanges, onAcceptChanges = param.onAcceptChanges, allowedSlippage = param.allowedSlippage;
    var ref, ref1;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var inputTextColor = showAcceptChanges && trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && isEnoughInputBalance ? "primary" : trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && !isEnoughInputBalance ? "failure" : "text";
    var amount = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? (ref = slippageAdjustedAmounts[swap_actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(6) : (ref1 = slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6);
    var symbol = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.outputAmount.currency.symbol : trade.inputAmount.currency.symbol;
    var tradeInfoText = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? t("Output is estimated. You will receive at least or the transaction will revert.") : t("Input is estimated. You will sell at most or the transaction will revert.");
    var ref2 = (0,_sliced_to_array/* default */.Z)(tradeInfoText.split("".concat(amount, " ").concat(symbol)), 2), estimatedText = ref2[0], transactionRevertText = ref2[1];
    var truncatedRecipient = recipient ? (0,truncateHash/* default */.Z)(recipient) : "";
    var recipientInfoText = t("Output will be sent to %recipient%", {
        recipient: truncatedRecipient
    });
    var ref3 = (0,_sliced_to_array/* default */.Z)(recipientInfoText.split(truncatedRecipient), 2), recipientSentToText = ref3[0], postSentToText = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        gap: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        gap: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                currency: trade.inputAmount.currency,
                                size: "24px",
                                style: {
                                    marginRight: "12px"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedText, {
                                fontSize: "24px",
                                color: inputTextColor,
                                children: trade.inputAmount.toSignificant(6)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                        gap: "0px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "24px",
                            ml: "10px",
                            children: trade.inputAmount.currency.symbol
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                    width: "16px",
                    ml: "4px"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                align: "flex-end",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        gap: "4px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* CurrencyLogo */.Xw, {
                                currency: trade.outputAmount.currency,
                                size: "24px"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedText, {
                                fontSize: "24px",
                                color: showAcceptChanges && trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? "primary" : "text",
                                children: trade.outputAmount.toSignificant(6)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "24px",
                            ml: "10px",
                            children: trade.outputAmount.currency.symbol
                        })
                    })
                ]
            }),
            showAcceptChanges ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapShowAcceptChanges, {
                justify: "flex-start",
                gap: "0px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_Error/* default */.Z, {
                                    mr: "8px"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    bold: true,
                                    children: [
                                        " ",
                                        t("Price Updated")
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            onClick: onAcceptChanges,
                            children: t("Accept")
                        })
                    ]
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                justify: "flex-start",
                gap: "sm",
                style: {
                    padding: "24px 0 0 0px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        style: {
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: "secondary",
                                bold: true,
                                textTransform: "uppercase",
                                children: t("Slippage tolerance")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                bold: true,
                                color: "primary",
                                ml: "auto",
                                textAlign: "end",
                                children: "".concat((0,utils_exchange/* basisPointsToPercent */.P4)(allowedSlippage).toFixed(1), "%")
                            })
                        ]
                    }),
                    trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && !isEnoughInputBalance && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        small: true,
                        color: "failure",
                        textAlign: "left",
                        style: {
                            width: "100%"
                        },
                        children: t("Insufficient input token balance. Your transaction may fail.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        small: true,
                        color: "textSubtle",
                        textAlign: "left",
                        style: {
                            width: "100%"
                        },
                        children: [
                            estimatedText,
                            transactionRevertText
                        ]
                    })
                ]
            }),
            recipient !== null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                justify: "flex-start",
                gap: "sm",
                style: {
                    padding: "12px 0 0 0px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    color: "textSubtle",
                    children: [
                        recipientSentToText,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            title: recipient,
                            children: truncatedRecipient
                        }),
                        postSentToText
                    ]
                })
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/StableSwap/components/StableSwapModalFooter.tsx

function StableSwapModalFooter_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  padding: 16px;\n  border-radius: ",
        ";\n  border: 1px solid ",
        ";\n  background-color: ",
        ";\n"
    ]);
    StableSwapModalFooter_templateObject = function _templateObject() {
        return data;
    };
    return data;
}













var StableSwapModalFooter_SwapModalFooterContainer = (0,styled_components_browser_esm/* default */.ZP)(Column/* AutoColumn */.Tz).withConfig({
    componentId: "sc-de6d2e82-0"
})(StableSwapModalFooter_templateObject(), function(param) {
    var theme = param.theme;
    return theme.radii.default;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
});
function StableSwapModalFooter(param) {
    var trade = param.trade, slippageAdjustedAmounts = param.slippageAdjustedAmounts, isEnoughInputBalance = param.isEnoughInputBalance, onConfirm = param.onConfirm, swapErrorMessage = param.swapErrorMessage, disabledConfirm = param.disabledConfirm;
    var ref, ref1;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref2 = (0,react.useState)(false), showInverted = ref2[0], setShowInverted = ref2[1];
    var totalFeePercent = "".concat((info/* TOTAL_FEE */.om * 100).toFixed(2), "%");
    var lpHoldersFeePercent = "".concat((info/* LP_HOLDERS_FEE */.BY * 100).toFixed(2), "%");
    var treasuryFeePercent = "".concat((info/* TREASURY_FEE */.hT * 100).toFixed(4), "%");
    var buyBackFeePercent = "".concat((info/* BUYBACK_FEE */.xy * 100).toFixed(4), "%");
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StableSwapModalFooter_SwapModalFooterContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                children: t("Price")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "14px",
                                style: {
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    textAlign: "right",
                                    paddingLeft: "10px"
                                },
                                children: [
                                    (0,utils_exchange/* formatExecutionPrice */.Kh)(trade, showInverted),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceMaxMini, {
                                        onClick: function() {
                                            return setShowInverted(!showInverted);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                                            width: "14px"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? t("Minimum received") : t("Maximum sold")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                        text: t("Your transaction will revert if there is a large, unfavorable price movement before it is confirmed."),
                                        ml: "4px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? (ref3 = (ref = slippageAdjustedAmounts[swap_actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(4)) !== null && ref3 !== void 0 ? ref3 : "-" : (ref4 = (ref1 = slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(4)) !== null && ref4 !== void 0 ? ref4 : "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        marginLeft: "4px",
                                        children: trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT ? trade.outputAmount.currency.symbol : trade.inputAmount.currency.symbol
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowBetween */.m0, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    fontSize: "14px",
                                    children: t("Liquidity Provider Fee")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                    text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                mb: "12px",
                                                children: t("For each trade a %amount% fee is paid", {
                                                    amount: totalFeePercent
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                children: [
                                                    "- ",
                                                    t("%amount% to LP token holders", {
                                                        amount: lpHoldersFeePercent
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                children: [
                                                    "- ",
                                                    t("%amount% to the Treasury", {
                                                        amount: treasuryFeePercent
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                                children: [
                                                    "- ",
                                                    t("%amount% towards CAKE buyback and burn", {
                                                        amount: buyBackFeePercent
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    ml: "4px"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "primary",
                        onClick: onConfirm,
                        disabled: disabledConfirm,
                        mt: "12px",
                        id: "confirm-swap-or-send",
                        width: "100%",
                        children: trade.tradeType === src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT && !isEnoughInputBalance ? t("Swap anyway") : t("Confirm swap")
                    }),
                    swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackError, {
                        error: swapErrorMessage
                    }) : null
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/TransactionConfirmSwapContent.tsx











/**
 * Returns true if the trade requires a confirmation of details before we can submit it
 * @param tradeA trade A
 * @param tradeB trade B
 */ function tradeMeaningfullyDiffers(tradeA, tradeB) {
    return tradeA.tradeType !== tradeB.tradeType || !tradeA.inputAmount.currency.equals(tradeB.inputAmount.currency) || !tradeA.inputAmount.equalTo(tradeB.inputAmount) || !tradeA.outputAmount.currency.equals(tradeB.outputAmount.currency) || !tradeA.outputAmount.equalTo(tradeB.outputAmount);
}
var TransactionConfirmSwapContent = function(param) {
    var trade = param.trade, originalTrade = param.originalTrade, onAcceptChanges = param.onAcceptChanges, allowedSlippage = param.allowedSlippage, onConfirm = param.onConfirm, recipient = param.recipient, currencyBalances = param.currencyBalances, isStable = param.isStable;
    var showAcceptChanges = (0,react.useMemo)(function() {
        return Boolean(trade && originalTrade && tradeMeaningfullyDiffers(trade, originalTrade));
    }, [
        originalTrade,
        trade
    ]);
    var slippageAdjustedAmounts = (0,react.useMemo)(function() {
        return (0,utils_exchange/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage);
    }, [
        trade,
        allowedSlippage
    ]);
    var isEnoughInputBalance = (0,react.useMemo)(function() {
        if ((trade === null || trade === void 0 ? void 0 : trade.tradeType) !== src/* TradeType.EXACT_OUTPUT */.YL.EXACT_OUTPUT) return null;
        var isInputBalanceExist = !!(currencyBalances && currencyBalances[swap_actions/* Field.INPUT */.gN.INPUT]);
        var isInputBalanceBNB = isInputBalanceExist && currencyBalances[swap_actions/* Field.INPUT */.gN.INPUT].currency.isNative;
        var inputCurrencyAmount = isInputBalanceExist ? isInputBalanceBNB ? (0,maxAmountSpend/* maxAmountSpend */.i)(currencyBalances[swap_actions/* Field.INPUT */.gN.INPUT]) : currencyBalances[swap_actions/* Field.INPUT */.gN.INPUT] : null;
        return inputCurrencyAmount && slippageAdjustedAmounts && slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT] ? inputCurrencyAmount.greaterThan(slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) || inputCurrencyAmount.equalTo(slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) : false;
    }, [
        currencyBalances,
        trade,
        slippageAdjustedAmounts
    ]);
    var modalHeader = (0,react.useCallback)(function() {
        var SwapModalHead = isStable ? StableSwapModalHeader : SwapModalHeader;
        return trade ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapModalHead, {
            trade: trade,
            allowedSlippage: allowedSlippage,
            slippageAdjustedAmounts: slippageAdjustedAmounts,
            isEnoughInputBalance: isEnoughInputBalance,
            recipient: recipient,
            showAcceptChanges: showAcceptChanges,
            onAcceptChanges: onAcceptChanges
        }) : null;
    }, [
        allowedSlippage,
        onAcceptChanges,
        recipient,
        showAcceptChanges,
        trade,
        slippageAdjustedAmounts,
        isEnoughInputBalance,
        isStable, 
    ]);
    var modalBottom = (0,react.useCallback)(function() {
        var SwapModalF = isStable ? StableSwapModalFooter : SwapModalFooter;
        return trade ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapModalF, {
            onConfirm: onConfirm,
            trade: trade,
            disabledConfirm: showAcceptChanges,
            slippageAdjustedAmounts: slippageAdjustedAmounts,
            isEnoughInputBalance: isEnoughInputBalance
        }) : null;
    }, [
        onConfirm,
        showAcceptChanges,
        trade,
        isEnoughInputBalance,
        slippageAdjustedAmounts,
        isStable
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* ConfirmationModalContent */.pM, {
        topContent: modalHeader,
        bottomContent: modalBottom
    });
};
/* harmony default export */ var components_TransactionConfirmSwapContent = (/*#__PURE__*/(0,react.memo)(TransactionConfirmSwapContent));

// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/Modal.tsx
var Modal = __webpack_require__(86876);
;// CONCATENATED MODULE: ./src/views/Swap/components/ConfirmSwapModalContainer.tsx



var ConfirmSwapModalContainer = function(param) {
    var children = param.children, handleDismiss = param.handleDismiss;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.ZP, {
        title: t("Confirm swap"),
        headerBackground: "gradientCardHeader",
        onDismiss: handleDismiss,
        children: children
    });
};
/* harmony default export */ var components_ConfirmSwapModalContainer = (ConfirmSwapModalContainer);

// EXTERNAL MODULE: ./packages/localization/src/useTranslation.ts
var useTranslation = __webpack_require__(71578);
;// CONCATENATED MODULE: ./src/views/Swap/components/ConfirmSwapModal.tsx









var PancakeRouterSlippageErrorMsg = "This transaction will not succeed either due to price movement or fee on transfer. Try increasing your slippage tolerance.";
var SwapTransactionErrorContent = function(param) {
    var onDismiss = param.onDismiss, message = param.message, openSettingModal = param.openSettingModal;
    var isSlippagedErrorMsg = message === null || message === void 0 ? void 0 : message.includes(PancakeRouterSlippageErrorMsg);
    var handleErrorDismiss = (0,react.useCallback)(function() {
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        if (isSlippagedErrorMsg && openSettingModal) {
            openSettingModal();
        }
    }, [
        isSlippagedErrorMsg,
        onDismiss,
        openSettingModal
    ]);
    var t = (0,useTranslation/* default */.Z)().t;
    return isSlippagedErrorMsg ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionErrorContent */.ht, {
        message: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    mb: "16px",
                    children: [
                        t("This transaction will not succeed either due to price movement or fee on transfer. Try increasing your"),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            bold: true,
                            display: "inline",
                            style: {
                                cursor: "pointer"
                            },
                            onClick: handleErrorDismiss,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                children: t("slippage tolerance.")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                    href: "https://docs.pancakeswap.finance/products/pancakeswap-exchange/trade-guide",
                    style: {
                        width: "100%",
                        justifyContent: "center"
                    },
                    children: t("What are the potential issues with the token?")
                })
            ]
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionErrorContent */.ht, {
        message: message,
        onDismiss: onDismiss
    });
};
var ConfirmSwapModal = function(param) {
    var trade = param.trade, originalTrade = param.originalTrade, currencyBalances = param.currencyBalances, onAcceptChanges = param.onAcceptChanges, allowedSlippage = param.allowedSlippage, onConfirm = param.onConfirm, onDismiss = param.onDismiss, customOnDismiss = param.customOnDismiss, recipient = param.recipient, swapErrorMessage = param.swapErrorMessage, attemptingTxn = param.attemptingTxn, txHash = param.txHash, openSettingModal = param.openSettingModal, isStable = param.isStable;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var handleDismiss = (0,react.useCallback)(function() {
        if (customOnDismiss) {
            customOnDismiss();
        }
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, [
        customOnDismiss,
        onDismiss
    ]);
    var confirmationContent = (0,react.useCallback)(function() {
        return swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapTransactionErrorContent, {
            openSettingModal: openSettingModal,
            onDismiss: onDismiss,
            message: swapErrorMessage
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TransactionConfirmSwapContent, {
            isStable: isStable,
            trade: trade,
            currencyBalances: currencyBalances,
            originalTrade: originalTrade,
            onAcceptChanges: onAcceptChanges,
            allowedSlippage: allowedSlippage,
            onConfirm: onConfirm,
            recipient: recipient
        });
    }, [
        isStable,
        trade,
        originalTrade,
        onAcceptChanges,
        allowedSlippage,
        onConfirm,
        recipient,
        swapErrorMessage,
        onDismiss,
        openSettingModal,
        currencyBalances, 
    ]);
    if (!chainId) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmSwapModalContainer, {
        handleDismiss: handleDismiss,
        children: attemptingTxn ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmationPendingContent, {
            trade: trade
        }) : txHash ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TransactionConfirmationModal/* TransactionSubmittedContent */.rD, {
            chainId: chainId,
            hash: txHash,
            onDismiss: handleDismiss,
            currencyToAdd: trade === null || trade === void 0 ? void 0 : trade.outputAmount.currency
        }) : confirmationContent()
    });
};
/* harmony default export */ var components_ConfirmSwapModal = (/*#__PURE__*/(0,react.memo)(ConfirmSwapModal));

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapCommitButton.tsx
























var SettingsModalWithCustomDismiss = (0,SettingsModal/* withCustomOnDismiss */.h)(SettingsModal/* default */.Z);
function SwapCommitButton(param) {
    var swapIsUnsupported = param.swapIsUnsupported, account = param.account, showWrap = param.showWrap, wrapInputError = param.wrapInputError, onWrap = param.onWrap, wrapType = param.wrapType, approval = param.approval, approveCallback = param.approveCallback, approvalSubmitted = param.approvalSubmitted, currencies = param.currencies, isExpertMode = param.isExpertMode, trade = param.trade, swapInputError = param.swapInputError, currencyBalances = param.currencyBalances, recipient = param.recipient, allowedSlippage = param.allowedSlippage, parsedIndepentFieldAmount = param.parsedIndepentFieldAmount, onUserInput = param.onUserInput;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSingleHopOnly */.RO)(), 1), singleHopOnly = ref[0];
    var priceImpactWithoutFee = (0,utils_exchange/* computeTradePriceBreakdown */.U7)(trade).priceImpactWithoutFee;
    // the callback to execute the swap
    var swapCalls = useSwapCallArguments(trade, allowedSlippage, recipient);
    var ref1 = useSwapCallback(trade, allowedSlippage, recipient, swapCalls), swapCallback = ref1.callback, swapCallbackError = ref1.error;
    var ref2 = (0,react.useState)({
        tradeToConfirm: undefined,
        attemptingTxn: false,
        swapErrorMessage: undefined,
        txHash: undefined
    }), ref3 = ref2[0], tradeToConfirm = ref3.tradeToConfirm, swapErrorMessage = ref3.swapErrorMessage, attemptingTxn = ref3.attemptingTxn, txHash = ref3.txHash, setSwapState = ref2[1];
    // Handlers
    var handleSwap = (0,react.useCallback)(function() {
        if (priceImpactWithoutFee && !confirmPriceImpactWithoutFee(priceImpactWithoutFee, t)) {
            return;
        }
        if (!swapCallback) {
            return;
        }
        setSwapState({
            attemptingTxn: true,
            tradeToConfirm: tradeToConfirm,
            swapErrorMessage: undefined,
            txHash: undefined
        });
        swapCallback().then(function(hash) {
            setSwapState({
                attemptingTxn: false,
                tradeToConfirm: tradeToConfirm,
                swapErrorMessage: undefined,
                txHash: hash
            });
        }).catch(function(error) {
            setSwapState({
                attemptingTxn: false,
                tradeToConfirm: tradeToConfirm,
                // swapErrorMessage: error.message,
                swapErrorMessage: "Swap failed: An unspecified error occurred. Please try again",
                txHash: undefined
            });
        });
    }, [
        priceImpactWithoutFee,
        swapCallback,
        tradeToConfirm,
        t,
        setSwapState
    ]);
    var handleAcceptChanges = (0,react.useCallback)(function() {
        setSwapState({
            tradeToConfirm: trade,
            swapErrorMessage: swapErrorMessage,
            txHash: txHash,
            attemptingTxn: attemptingTxn
        });
    }, [
        attemptingTxn,
        swapErrorMessage,
        trade,
        txHash,
        setSwapState
    ]);
    var handleConfirmDismiss = (0,react.useCallback)(function() {
        setSwapState({
            tradeToConfirm: tradeToConfirm,
            attemptingTxn: attemptingTxn,
            swapErrorMessage: swapErrorMessage,
            txHash: txHash
        });
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            onUserInput(swap_actions/* Field.INPUT */.gN.INPUT, "");
        }
    }, [
        attemptingTxn,
        onUserInput,
        swapErrorMessage,
        tradeToConfirm,
        txHash,
        setSwapState
    ]);
    // End Handlers
    // Modals
    var ref4 = (0,react.useState)(false), indirectlyOpenConfirmModalState = ref4[0], setIndirectlyOpenConfirmModalState = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(SettingsModalWithCustomDismiss, {
        customOnDismiss: function() {
            return setIndirectlyOpenConfirmModalState(true);
        },
        mode: GlobalSettings_types/* SettingsMode.SWAP_LIQUIDITY */.a.SWAP_LIQUIDITY
    })), 1), onPresentSettingsModal = ref5[0];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ConfirmSwapModal, {
        trade: trade,
        originalTrade: tradeToConfirm,
        currencyBalances: currencyBalances,
        onAcceptChanges: handleAcceptChanges,
        attemptingTxn: attemptingTxn,
        txHash: txHash,
        recipient: recipient,
        allowedSlippage: allowedSlippage,
        onConfirm: handleSwap,
        swapErrorMessage: swapErrorMessage,
        customOnDismiss: handleConfirmDismiss,
        openSettingModal: onPresentSettingsModal
    }), true, true, "confirmSwapModal"), 1), onPresentConfirmModal = ref6[0];
    // End Modals
    var onSwapHandler = (0,react.useCallback)(function() {
        if (isExpertMode) {
            handleSwap();
        } else {
            setSwapState({
                tradeToConfirm: trade,
                attemptingTxn: false,
                swapErrorMessage: undefined,
                txHash: undefined
            });
            onPresentConfirmModal();
        }
    }, [
        isExpertMode,
        handleSwap,
        onPresentConfirmModal,
        trade
    ]);
    // useEffect
    (0,react.useEffect)(function() {
        if (indirectlyOpenConfirmModalState) {
            setIndirectlyOpenConfirmModalState(false);
            setSwapState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    swapErrorMessage: undefined
                });
            });
            onPresentConfirmModal();
        }
    }, [
        indirectlyOpenConfirmModalState,
        onPresentConfirmModal,
        setSwapState
    ]);
    // warnings on slippage
    var priceImpactSeverity = (0,utils_exchange/* warningSeverity */.oX)(priceImpactWithoutFee);
    if (swapIsUnsupported) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            width: "100%",
            disabled: true,
            children: t("Unsupported Asset")
        });
    }
    if (!account) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* default */.Z, {
            width: "100%"
        });
    }
    if (showWrap) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
            style: {
                marginTop: "15px"
            },
            width: "100%",
            disabled: Boolean(wrapInputError),
            onClick: onWrap,
            children: wrapInputError !== null && wrapInputError !== void 0 ? wrapInputError : wrapType === WrapType.WRAP ? "Wrap" : wrapType === WrapType.UNWRAP ? "Unwrap" : null
        });
    }
    var noRoute = !(trade === null || trade === void 0 ? void 0 : trade.route);
    var userHasSpecifiedInputOutput = Boolean(currencies[swap_actions/* Field.INPUT */.gN.INPUT] && currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT] && (parsedIndepentFieldAmount === null || parsedIndepentFieldAmount === void 0 ? void 0 : parsedIndepentFieldAmount.greaterThan(exchange/* BIG_INT_ZERO */.iV)));
    if (noRoute && userHasSpecifiedInputOutput) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            style: {
                textAlign: "center",
                padding: "0.75rem"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommitButton/* CommitButton */.A, {
                    disabled: true,
                    color: "textDisable",
                    children: [
                        " ",
                        t("Insufficient liquidity for this trade.")
                    ]
                }),
                singleHopOnly && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "textSubtle",
                    children: t("Try enabling multi-hop trades.")
                })
            ]
        });
    }
    // show approve flow when: no error on inputs, not approved or pending, or approved in current session
    // never show if price impact is above threshold in non expert mode
    var showApproveFlow = !swapInputError && (approval === useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approval === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING || approvalSubmitted && approval === useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED) && !(priceImpactSeverity > 3 && !isExpertMode);
    var isValid = !swapInputError;
    if (showApproveFlow) {
        var ref7;
        var ref8;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
                            variant: approval === useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED ? "success" : "primary",
                            onClick: approveCallback,
                            disabled: approval !== useApproveCallback/* ApprovalState.NOT_APPROVED */.UK.NOT_APPROVED || approvalSubmitted,
                            width: "48%",
                            children: approval === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                gap: "6px",
                                justify: "center",
                                children: [
                                    t("Enabling"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CircleLoader/* default */.Z, {
                                        stroke: "textDisabled"
                                    })
                                ]
                            }) : approvalSubmitted && approval === useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED ? t("Enabled") : t("Enable %asset%", {
                                asset: (ref8 = (ref7 = currencies[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref7 === void 0 ? void 0 : ref7.symbol) !== null && ref8 !== void 0 ? ref8 : ""
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
                            // variant={isValid && priceImpactSeverity > 2 ? 'light' : 'primary' }
                            onClick: function() {
                                onSwapHandler();
                            },
                            width: "48%",
                            id: "swap-button",
                            disabled: !isValid || approval !== useApproveCallback/* ApprovalState.APPROVED */.UK.APPROVED || priceImpactSeverity > 3 && !isExpertMode,
                            children: priceImpactSeverity > 3 && !isExpertMode ? t("Price impact high") : priceImpactSeverity > 2 ? t("Swap anyway") : t("Swap")
                        })
                    ]
                }),
                isExpertMode && swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackError, {
                    error: swapErrorMessage
                }) : null
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommitButton/* CommitButton */.A, {
                // variant={isValid && priceImpactSeverity > 2 && !swapCallbackError ? 'light' : 'primary'}
                onClick: function() {
                    onSwapHandler();
                },
                id: "swap-button",
                width: "80%",
                disabled: !isValid || priceImpactSeverity > 3 && !isExpertMode || !!swapCallbackError,
                children: swapInputError || (priceImpactSeverity > 3 && !isExpertMode ? t("Price impact too high") : priceImpactSeverity > 2 ? t("Swap anyway") : t("Swap"))
            }),
            isExpertMode && swapErrorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapCallbackError, {
                error: swapErrorMessage
            }) : null
        ]
    });
}

// EXTERNAL MODULE: ./packages/tokens/src/index.ts + 8 modules
var tokens_src = __webpack_require__(30693);
;// CONCATENATED MODULE: ./src/config/constants/warningTokens.ts

var bscWarningTokens = {
    pokemoney: new src/* Token */.WU(src/* ChainId.BSC */.a_.BSC, "0x32ff5b4C3B1744F0344D96fA2f87799Ed2805749", 18, "PMY", "Pokemoney Coin", ""),
    free: new src/* Token */.WU(src/* ChainId.BSC */.a_.BSC, "0x880BCe9321c79cAc1D290De6d31DDE722C606165", 8, "FREE", "Freedom Protocol Token", ""),
    safemoon: new src/* Token */.WU(src/* ChainId.BSC */.a_.BSC, "0x8076C74C5e3F5852037F31Ff0093Eeb8c8ADd8D3", 9, "SAFEMOON", "Safemoon Token", "https://safemoon.net/")
};
var bscTestnetWarningTokens = {};

;// CONCATENATED MODULE: ./src/config/constants/swapWarningTokens.ts


var bondly = tokens_src/* bscTokens.bondly */.ds.bondly, itam = tokens_src/* bscTokens.itam */.ds.itam, ccar = tokens_src/* bscTokens.ccar */.ds.ccar, bttold = tokens_src/* bscTokens.bttold */.ds.bttold;
var pokemoney = bscWarningTokens.pokemoney, free = bscWarningTokens.free, safemoon = bscWarningTokens.safemoon;
var SwapWarningTokens = {
    safemoon: safemoon,
    bondly: bondly,
    itam: itam,
    ccar: ccar,
    bttold: bttold,
    pokemoney: pokemoney,
    free: free
};
/* harmony default export */ var swapWarningTokens = (SwapWarningTokens);

;// CONCATENATED MODULE: ./src/utils/shouldShowSwapWarning.ts

var shouldShowSwapWarning_swapWarningTokens = Object.values(swapWarningTokens);
var shouldShowSwapWarning = function(swapCurrency) {
    return shouldShowSwapWarning_swapWarningTokens.some(function(warningToken) {
        return warningToken.equals(swapCurrency);
    });
};
/* harmony default export */ var utils_shouldShowSwapWarning = (shouldShowSwapWarning);

// EXTERNAL MODULE: ./src/components/SearchModal/ImportToken.tsx
var ImportToken = __webpack_require__(97139);
;// CONCATENATED MODULE: ./src/components/ImportTokenWarningModal.tsx




var ImportTokenWarningModal = function(param) {
    var tokens = param.tokens, onDismiss = param.onDismiss, onCancel = param.onCancel;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.ZP, {
        title: t("Import Token"),
        onDismiss: function() {
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
            onCancel();
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            maxWidth: "380px",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImportToken/* default */.Z, {
                tokens: tokens,
                handleCurrencySelect: onDismiss
            })
        })
    });
};
/* harmony default export */ var components_ImportTokenWarningModal = (ImportTokenWarningModal);

// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var styles = __webpack_require__(51944);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(55421);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(199);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/SafemoonWarning.tsx



var SafemoonWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    // Break translation sentences into pieces because the current translation approach doesn't support Link interpolation.
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            children: [
                t("SAFEMOON has been migrated to"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://bscscan.com/address/0x42981d0bfbAf196529376EE702F2a9Eb9092fcB5",
                    children: t("a new contract address.")
                }),
                " ",
                t("Trading on the old address may result in the complete loss of your assets. For more information please refer to"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://twitter.com/safemoon/status/1477770592031887360",
                    children: [
                        t("Safemoon's announcement"),
                        "."
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_SafemoonWarning = (SafemoonWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/ItamWarning.tsx



var ItamWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            children: [
                t("ITAM has been rebranded as ITAM CUBE."),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://itam.network/swap",
                    children: t("Please proceed to ITAM bridge to conduct a one-way swap of your ITAM tokens.")
                }),
                " ",
                t("All transfers of the old ITAM token will be disabled after the swap.")
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_ItamWarning = (ItamWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/BondlyWarning.tsx



var BondlyWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        children: t("Warning: BONDLY has been compromised. Please remove liquidity until further notice.")
    });
};
/* harmony default export */ var SwapWarningModal_BondlyWarning = (BondlyWarning);

// EXTERNAL MODULE: ./packages/uikit/src/components/Checkbox/Checkbox.tsx
var Checkbox = __webpack_require__(68434);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/Acknowledgement.tsx




var Acknowledgement = function(param) {
    var handleContinueClick = param.handleContinueClick;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), isConfirmed = ref[0], setIsConfirmed = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            justifyContent: "space-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            name: "confirmed",
                            type: "checkbox",
                            checked: isConfirmed,
                            onChange: function() {
                                return setIsConfirmed(!isConfirmed);
                            },
                            scale: "sm"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            ml: "10px",
                            style: {
                                userSelect: "none"
                            },
                            children: t("I understand")
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    disabled: !isConfirmed,
                    onClick: handleContinueClick,
                    children: t("Continue")
                })
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_Acknowledgement = (Acknowledgement);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/CcarWarning.tsx



var CcarWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
            children: [
                t("Crypto Cars (CCAR) has been migrated to"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://bscscan.com/token/0x322e5015Cc464Ada7f99dE7131CE494dE1834396",
                    children: t("a new contract address.")
                }),
                " ",
                t("Trading on the old address may result in the complete loss of your assets. For more information please refer to"),
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    style: {
                        display: "inline"
                    },
                    external: true,
                    href: "https://t.me/Crypto_Cars_Official/465037",
                    children: t("the announcement.")
                })
            ]
        })
    });
};
/* harmony default export */ var SwapWarningModal_CcarWarning = (CcarWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/BTTWarning.tsx



var BTTWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: t("Please note that this is the old BTT token, which has been swapped to the new BTT tokens in the following ratio:")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                children: "1 BTT (OLD) = 1,000 BTT (NEW)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                mb: "8px",
                children: [
                    t("Trade the new BTT token"),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        style: {
                            display: "inline"
                        },
                        href: "https://pancakeswap.finance/swap?outputCurrency=0x352Cb5E19b12FC216548a2677bD0fce83BaE434B",
                        children: t("here")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkExternal/* default */.Z, {
                href: "https://medium.com/@BitTorrent/tutorial-how-to-swap-bttold-to-btt-453264d7142",
                children: t("For more details on the swap, please refer here.")
            })
        ]
    });
};
/* harmony default export */ var SwapWarningModal_BTTWarning = (BTTWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/RugPullWarning.tsx



var RugPullWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            color: "white",
            children: t("Suspicious rugpull token")
        })
    });
};
/* harmony default export */ var SwapWarningModal_RugPullWarning = (RugPullWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/FREEWarning.tsx



var FREEWarning = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            children: t("Risk Warning: This token is subject to high price risk. Please do your own research before trading this token. Please also note that as of 24 June 2022 there is also a reflection fee for every transfer of FREE ranging from 2.5 to 5% per trade/transfer.")
        })
    });
};
/* harmony default export */ var SwapWarningModal_FREEWarning = (FREEWarning);

;// CONCATENATED MODULE: ./src/views/Swap/components/SwapWarningModal/index.tsx


function SwapWarningModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 440px;\n"
    ]);
    SwapWarningModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SwapWarningModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: flex-start;\n  justify-content: flex-start;\n"
    ]);
    SwapWarningModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var StyledModalContainer = (0,styled_components_browser_esm/* default */.ZP)(styles/* ModalContainer */.F0).withConfig({
    componentId: "sc-ba5edbbc-0"
})(SwapWarningModal_templateObject());
var MessageContainer = (0,styled_components_browser_esm/* default */.ZP)(Message/* default */.Z).withConfig({
    componentId: "sc-ba5edbbc-1"
})(SwapWarningModal_templateObject1());
var SwapWarningModal = function(param) {
    var swapCurrency = param.swapCurrency, onDismiss = param.onDismiss;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var _obj;
    var TOKEN_WARNINGS = (_obj = {}, (0,_define_property/* default */.Z)(_obj, swapWarningTokens.safemoon.address, {
        symbol: swapWarningTokens.safemoon.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_SafemoonWarning, {})
    }), (0,_define_property/* default */.Z)(_obj, swapWarningTokens.bondly.address, {
        symbol: swapWarningTokens.bondly.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_BondlyWarning, {})
    }), (0,_define_property/* default */.Z)(_obj, swapWarningTokens.itam.address, {
        symbol: swapWarningTokens.itam.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_ItamWarning, {})
    }), (0,_define_property/* default */.Z)(_obj, swapWarningTokens.ccar.address, {
        symbol: swapWarningTokens.ccar.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_CcarWarning, {})
    }), (0,_define_property/* default */.Z)(_obj, swapWarningTokens.bttold.address, {
        symbol: swapWarningTokens.bttold.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_BTTWarning, {})
    }), (0,_define_property/* default */.Z)(_obj, swapWarningTokens.pokemoney.address, {
        symbol: swapWarningTokens.pokemoney.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_RugPullWarning, {})
    }), (0,_define_property/* default */.Z)(_obj, swapWarningTokens.free.address, {
        symbol: swapWarningTokens.free.symbol,
        component: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_FREEWarning, {})
    }), _obj);
    var SWAP_WARNING = TOKEN_WARNINGS[swapCurrency.address];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalContainer, {
        minWidth: "280px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* ModalHeader */.xB, {
                background: theme.colors.gradientCardHeader,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                    p: "12px 24px",
                    children: t("Notice for trading %symbol%", {
                        symbol: SWAP_WARNING.symbol
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* ModalBody */.fe, {
                p: "24px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MessageContainer, {
                        variant: "warning",
                        mb: "24px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: SWAP_WARNING.component
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapWarningModal_Acknowledgement, {
                        handleContinueClick: onDismiss
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_SwapWarningModal = (SwapWarningModal);

;// CONCATENATED MODULE: ./src/views/Swap/hooks/useWarningImport.tsx











function useWarningImport() {
    var router = (0,next_router.useRouter)();
    var loadedUrlParams = (0,hooks/* useDefaultsFromURLSearch */.jj)();
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    // swap warning state
    var ref = (0,react.useState)(null), swapWarningCurrency = ref[0], setSwapWarningCurrency = ref[1];
    // token warning stuff
    var ref1 = [
        (0,Tokens/* useCurrency */.U8)(loadedUrlParams === null || loadedUrlParams === void 0 ? void 0 : loadedUrlParams.inputCurrencyId),
        (0,Tokens/* useCurrency */.U8)(loadedUrlParams === null || loadedUrlParams === void 0 ? void 0 : loadedUrlParams.outputCurrencyId), 
    ], loadedInputCurrency = ref1[0], loadedOutputCurrency = ref1[1];
    var ref2;
    var urlLoadedTokens = (0,react.useMemo)(function() {
        var ref;
        return (ref2 = (ref = [
            loadedInputCurrency,
            loadedOutputCurrency
        ]) === null || ref === void 0 ? void 0 : ref.filter(function(c) {
            return c === null || c === void 0 ? void 0 : c.isToken;
        })) !== null && ref2 !== void 0 ? ref2 : [];
    }, [
        loadedInputCurrency,
        loadedOutputCurrency
    ]);
    var defaultTokens = (0,Tokens/* useAllTokens */.e_)();
    var importTokensNotInDefault = urlLoadedTokens && urlLoadedTokens.filter(function(token) {
        return !(token.address in defaultTokens) && token.chainId === chainId;
    });
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_SwapWarningModal, {
        swapCurrency: swapWarningCurrency
    }), false), 1), onPresentSwapWarningModal = ref3[0];
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ImportTokenWarningModal, {
        tokens: importTokensNotInDefault,
        onCancel: function() {
            return router.push("/swap");
        }
    })), 1), onPresentImportTokenWarningModal = ref4[0];
    (0,react.useEffect)(function() {
        if (swapWarningCurrency) {
            onPresentSwapWarningModal();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        swapWarningCurrency
    ]);
    var swapWarningHandler = (0,react.useCallback)(function(currencyInput) {
        var showSwapWarning = utils_shouldShowSwapWarning(currencyInput);
        if (showSwapWarning) {
            setSwapWarningCurrency(currencyInput);
        } else {
            setSwapWarningCurrency(null);
        }
    }, []);
    (0,react.useEffect)(function() {
        if (importTokensNotInDefault.length > 0) {
            onPresentImportTokenWarningModal();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        importTokensNotInDefault.length
    ]);
    return swapWarningHandler;
}

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/views/Swap/hooks/useRefreshBlockNumber.ts



var useRefreshBlockNumber = function() {
    var ref = (0,react.useState)(false), isLoading = ref[0], setFetch = ref[1];
    var refreshBlockNumber = (0,react.useCallback)(function() {
        if (!isLoading) {
            setFetch(true);
        }
    }, [
        isLoading
    ]);
    var mutate = (0,dist/* useSWRConfig */.kY)().mutate;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    (0,react.useEffect)(function() {
        if (!isLoading) return;
        mutate([
            "blockNumber",
            chainId
        ]);
        // setTimeout is used to demonstrate the loading
        // because the real loading state occurs on multicall state
        // we don't know when the fetch is finished.
        setTimeout(function() {
            return setFetch(false);
        }, 500);
    }, [
        mutate,
        isLoading,
        chainId
    ]);
    return {
        refreshBlockNumber: refreshBlockNumber,
        isLoading: isLoading
    };
};
/* harmony default export */ var hooks_useRefreshBlockNumber = (useRefreshBlockNumber);

;// CONCATENATED MODULE: ./src/views/Swap/components/AddressInputPanel.tsx

function AddressInputPanel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-flow: column nowrap;\n  position: relative;\n  border-radius: 1.25rem;\n  background-color: ",
        ";\n  z-index: 1;\n  width: 100%;\n"
    ]);
    AddressInputPanel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AddressInputPanel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 1.25rem;\n  border: 1px solid ",
        ";\n  transition: border-color 300ms ",
        ",\n    color 500ms ",
        ";\n  background-color: ",
        ";\n"
    ]);
    AddressInputPanel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AddressInputPanel_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  padding: 1rem;\n"
    ]);
    AddressInputPanel_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AddressInputPanel_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 1.25rem;\n  outline: none;\n  border: none;\n  flex: 1 1 auto;\n  background-color: ",
        ";\n  transition: color 300ms ",
        ";\n  color: ",
        ";\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 500;\n  width: 100%;\n  ::placeholder {\n    color: ",
        ";\n  }\n  padding: 0px;\n  -webkit-appearance: textfield;\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  ::-webkit-outer-spin-button,\n  ::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n  }\n\n  ::placeholder {\n    color: ",
        ";\n  }\n"
    ]);
    AddressInputPanel_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}










var InputPanel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-966d56e6-0"
})(AddressInputPanel_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var ContainerRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-966d56e6-1"
})(AddressInputPanel_templateObject1(), function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.background;
}, function(param) {
    var error = param.error;
    return error ? "step-end" : "step-start";
}, function(param) {
    var error = param.error;
    return error ? "step-end" : "step-start";
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var InputContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-966d56e6-2"
})(AddressInputPanel_templateObject2());
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-966d56e6-3"
})(AddressInputPanel_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
}, function(param) {
    var error = param.error;
    return error ? "step-end" : "step-start";
}, function(param) {
    var error = param.error, theme = param.theme;
    return error ? theme.colors.failure : theme.colors.primary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
});
function AddressInputPanel(param) {
    var id = param.id, value = param.value, onChange = param.onChange;
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var address = (0,utils/* isAddress */.UJ)(value) ? value : undefined;
    var handleInput = (0,react.useCallback)(function(event) {
        var input = event.target.value;
        var withoutSpaces = input.replace(/\s+/g, "");
        onChange(withoutSpaces);
    }, [
        onChange
    ]);
    var error = Boolean(value.length > 0 && !address);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputPanel, {
        id: id,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerRow, {
            error: error,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    gap: "md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    children: t("Recipient")
                                }),
                                address && chainId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                    external: true,
                                    small: true,
                                    href: (0,utils/* getBlockExploreLink */.C)(address, "address", chainId),
                                    children: [
                                        "(",
                                        t("View on %site%", {
                                            site: (0,utils/* getBlockExploreName */.X0)(chainId)
                                        }),
                                        ")"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                            className: "recipient-address-input",
                            type: "text",
                            autoComplete: "off",
                            autoCorrect: "off",
                            autoCapitalize: "off",
                            spellCheck: "false",
                            placeholder: t("Wallet Address"),
                            error: error,
                            pattern: "^(0x[a-fA-F0-9]{40})$",
                            onChange: handleInput,
                            value: value
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/hooks/useLast.ts

/**
 * Returns the last value of type T that passes a filter function
 * @param value changing value
 * @param filterFn function that determines whether a given value should be considered for the last value
 */ function useLast(value, filterFn) {
    var ref = (0,react.useState)(function() {
        return filterFn && filterFn(value) ? value : undefined;
    }), last = ref[0], setLast = ref[1];
    (0,react.useEffect)(function() {
        setLast(function(prev) {
            var shouldUse = filterFn ? filterFn(value) : true;
            if (shouldUse) return value;
            return prev;
        });
    }, [
        filterFn,
        value
    ]);
    return last;
}
function isDefined(x) {
    return x !== null && x !== undefined;
}
/**
 * Returns the last truthy value of type T
 * @param value changing value
 */ function useLastTruthy(value) {
    return useLast(value, isDefined);
}
/* harmony default export */ var hooks_useLast = (useLastTruthy);

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(86141);
// EXTERNAL MODULE: ./src/utils/wrappedCurrency.ts
var wrappedCurrency = __webpack_require__(73938);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapRoute.tsx




/* harmony default export */ var SwapRoute = (/*#__PURE__*/(0,react.memo)(function SwapRoute(param) {
    var trade = param.trade;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        flexWrap: "wrap",
        width: "100%",
        justifyContent: "flex-end",
        alignItems: "center",
        children: trade.route.path.map(function(token, i, path) {
            var isLastItem = i === path.length - 1;
            var currency = (0,wrappedCurrency/* unwrappedToken */.Bv)(token);
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        alignItems: "end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            ml: "0.125rem",
                            mr: "0.125rem",
                            children: currency.symbol
                        })
                    }),
                    !isLastItem && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight/* default */.Z, {
                        width: "12px"
                    })
                ]
            }, token.address);
        })
    });
}));

;// CONCATENATED MODULE: ./src/views/Swap/components/AdvancedSwapDetails.tsx


function AdvancedSwapDetails_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overflow-wrap: anywhere;\n  width: 50%;\n  justify-content: flex-end;\n"
    ]);
    AdvancedSwapDetails_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














function TradeSummary(param) {
    var trade = param.trade, allowedSlippage = param.allowedSlippage;
    var ref, ref1;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref2 = (0,utils_exchange/* computeTradePriceBreakdown */.U7)(trade), priceImpactWithoutFee = ref2.priceImpactWithoutFee, realizedLPFee = ref2.realizedLPFee;
    var isExactIn = trade.tradeType === src/* TradeType.EXACT_INPUT */.YL.EXACT_INPUT;
    var slippageAdjustedAmounts = (0,utils_exchange/* computeSlippageAdjustedAmounts */.b5)(trade, allowedSlippage);
    var totalFeePercent = "".concat((info/* TOTAL_FEE */.om * 100).toFixed(2), "%");
    var lpHoldersFeePercent = "".concat((info/* LP_HOLDERS_FEE */.BY * 100).toFixed(2), "%");
    var treasuryFeePercent = "".concat((info/* TREASURY_FEE */.hT * 100).toFixed(4), "%");
    var buyBackFeePercent = "".concat((info/* BUYBACK_FEE */.xy * 100).toFixed(4), "%");
    var ref3, ref4;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        style: {
            padding: "0 16px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                color: "text",
                                children: isExactIn ? t("Minimum received") : t("Maximum sold")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                text: t("Your transaction will revert if there is a large, unfavorable price movement before it is confirmed."),
                                ml: "4px",
                                placement: "top-start"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            color: "text",
                            children: isExactIn ? (ref3 = "".concat(Number((ref = slippageAdjustedAmounts[swap_actions/* Field.OUTPUT */.gN.OUTPUT]) === null || ref === void 0 ? void 0 : ref.toSignificant(4)).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }), " ").concat(trade.outputAmount.currency.symbol)) !== null && ref3 !== void 0 ? ref3 : "-" : (ref4 = "".concat(Number((ref1 = slippageAdjustedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(4)).toLocaleString("en", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }), " ").concat(trade.inputAmount.currency.symbol)) !== null && ref4 !== void 0 ? ref4 : "-"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowFixed */.DA, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                fontSize: "14px",
                                color: "text",
                                children: t("Price impact")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                text: t("The difference between the market price and estimated price due to trade size."),
                                ml: "4px",
                                placement: "top-start"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormattedPriceImpact, {
                        priceImpact: priceImpactWithoutFee
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowFixed */.DA, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            color: "text",
                            children: t("Liquidity provider fee")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CsFlex, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            children: realizedLPFee ? "".concat(realizedLPFee.toSignificant(4), " ").concat(trade.inputAmount.currency.symbol) : "-"
                        })
                    })
                ]
            })
        ]
    });
}
function AdvancedSwapDetails(param) {
    var trade = param.trade;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref[0];
    var showRoute = Boolean(trade && trade.route.path.length >= 2);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
        gap: "0px",
        children: trade && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TradeSummary, {
                    trade: trade,
                    allowedSlippage: allowedSlippage
                }),
                showRoute && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                        style: {
                            padding: "0 16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                style: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        color: "text",
                                        children: t("Route")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                        text: t("Routing through these tokens resulted in the best price for your trade."),
                                        ml: "4px",
                                        placement: "top-start"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapRoute, {
                                trade: trade
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var CsFlex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-87e0fad7-0"
})(AdvancedSwapDetails_templateObject());

;// CONCATENATED MODULE: ./src/views/Swap/components/AdvancedSwapDetailsDropdown.tsx




function AdvancedSwapDetailsDropdown_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: ",
        ";\n  padding-top: 16px;\n  padding-bottom: 16px;\n  width: 100%;\n  border-radius: 20px;\n  background-color: transparent;\n\n  transform: ",
        ";\n  transition: transform 300ms ease-in-out;\n"
    ]);
    AdvancedSwapDetailsDropdown_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var AdvancedDetailsFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ccda6e6d-0"
})(AdvancedSwapDetailsDropdown_templateObject(), function(param) {
    var show = param.show;
    return show ? "16px" : 0;
}, function(param) {
    var show = param.show;
    return show ? "translateY(0%)" : "translateY(-100%)";
});
function AdvancedSwapDetailsDropdown(_param) {
    var trade = _param.trade, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "trade"
    ]);
    var lastTrade = hooks_useLast(trade);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedDetailsFooter, {
        show: Boolean(trade),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedSwapDetails, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            trade: (ref = trade !== null && trade !== void 0 ? trade : lastTrade) !== null && ref !== void 0 ? ref : undefined
        }))
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/components/TradePrice.tsx

function TradePrice_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overflow-wrap: anywhere;\n  width: 100%;\n  justify-content: flex-end;\n  font-family: 'Marcellus', serif;\n"
    ]);
    TradePrice_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function TradePrice(param) {
    var price = param.price, showInverted = param.showInverted, setShowInverted = param.setShowInverted;
    var ref, ref1, ref2, ref3, ref4;
    var formattedPrice = showInverted ? price === null || price === void 0 ? void 0 : price.toSignificant(6) : (ref = price === null || price === void 0 ? void 0 : price.invert()) === null || ref === void 0 ? void 0 : ref.toSignificant(6);
    var show = Boolean((price === null || price === void 0 ? void 0 : price.baseCurrency) && (price === null || price === void 0 ? void 0 : price.quoteCurrency));
    var label = showInverted ? "".concat(price === null || price === void 0 ? void 0 : (ref1 = price.quoteCurrency) === null || ref1 === void 0 ? void 0 : ref1.symbol, " per ").concat(price === null || price === void 0 ? void 0 : (ref2 = price.baseCurrency) === null || ref2 === void 0 ? void 0 : ref2.symbol) : "".concat(price === null || price === void 0 ? void 0 : (ref3 = price.baseCurrency) === null || ref3 === void 0 ? void 0 : ref3.symbol, " per ").concat(price === null || price === void 0 ? void 0 : (ref4 = price.quoteCurrency) === null || ref4 === void 0 ? void 0 : ref4.symbol);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: {
            justifyContent: "flex-end",
            alignItems: "center",
            display: "flex",
            flexWrap: "wrap"
        },
        children: show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            flexDirection: "row",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TradePrice_CsFlex, {
                    children: [
                        formattedPrice !== null && formattedPrice !== void 0 ? formattedPrice : "-",
                        " ",
                        label
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBalanceMaxMini, {
                    onClick: function() {
                        return setShowInverted(!showInverted);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        width: "14px"
                    })
                })
            ]
        }) : "-"
    });
}
var TradePrice_CsFlex = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f96bafa9-0"
})(TradePrice_templateObject());

// EXTERNAL MODULE: ./src/views/Swap/StableSwap/hooks/useStableConfig.ts + 3 modules
var useStableConfig = __webpack_require__(57487);
;// CONCATENATED MODULE: ./src/views/Swap/components/SwapForm.tsx



function SwapForm_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  color: ",
        ";\n"
    ]);
    SwapForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SwapForm_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color:transparent;\n  /* .icon-up-down {\n    display: none;\n  }\n  &:hover {\n    background-color: ",
        ";\n    .icon-down {\n      display: none;\n      fill: white;\n    }\n    .icon-up-down {\n      display: block;\n      fill: white;\n    }\n  } */\n"
    ]);
    SwapForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SwapForm_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n   display:flex;\n   justify-content:center;\n   width:80%;\n"
    ]);
    SwapForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SwapForm_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n margin:0.25rem auto 0;\n display:flex;\n justify-content:center;\n width:80%;\n @media (max-width:600px) {\n   width:100%;\n }\n"
    ]);
    SwapForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SwapForm_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    border: 1px solid ",
        ";\n    padding: 10px;\n    height: 100px;\n"
    ]);
    SwapForm_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
































var Label = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
    componentId: "sc-843be3b9-0"
})(SwapForm_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var SwitchIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-843be3b9-1"
})(SwapForm_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var CsSwapCommitButton = (0,styled_components_browser_esm/* default */.ZP)(SwapCommitButton).withConfig({
    componentId: "sc-843be3b9-2"
})(SwapForm_templateObject2());
var CsBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-843be3b9-3"
})(SwapForm_templateObject3());
var ContainerCurrency = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-843be3b9-4"
})(SwapForm_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
function SwapForm(param) {
    var setIsChartDisplayed = param.setIsChartDisplayed, isChartDisplayed = param.isChartDisplayed, isAccessTokenSupported = param.isAccessTokenSupported;
    var ref, ref1, ref2;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref3 = hooks_useRefreshBlockNumber(), refreshBlockNumber = ref3.refreshBlockNumber, isLoading = ref3.isLoading;
    var stableFarms = (0,useStableConfig/* useStableFarms */.rS)();
    var warningSwapHandler = useWarningImport();
    var ref4 = (0,useActiveWeb3React/* default */.Z)(), account = ref4.account, chainId = ref4.chainId;
    // for expert mode
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useExpertModeManager */.DG)(), 1), isExpertMode = ref5[0];
    // get custom setting values for user
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useUserSlippageTolerance */.$2)(), 1), allowedSlippage = ref6[0];
    // swap state & price data
    var ref7 = (0,hooks/* useSwapState */.dU)(), independentField = ref7.independentField, typedValue = ref7.typedValue, recipient = ref7.recipient, _INPUT = ref7[swap_actions/* Field.INPUT */.gN.INPUT], inputCurrencyId = _INPUT.currencyId, _OUTPUT = ref7[swap_actions/* Field.OUTPUT */.gN.OUTPUT], outputCurrencyId = _OUTPUT.currencyId;
    var inputCurrency = (0,Tokens/* useCurrency */.U8)(inputCurrencyId);
    var outputCurrency = (0,Tokens/* useCurrency */.U8)(outputCurrencyId);
    var hasStableSwapAlternative = (0,react.useMemo)(function() {
        return stableFarms.some(function(stableFarm) {
            var checkSummedToken0 = (0,utils/* isAddress */.UJ)(stableFarm === null || stableFarm === void 0 ? void 0 : stableFarm.token0.address);
            var checkSummedToken1 = (0,utils/* isAddress */.UJ)(stableFarm === null || stableFarm === void 0 ? void 0 : stableFarm.token1.address);
            return (checkSummedToken0 === inputCurrencyId || checkSummedToken0 === outputCurrencyId) && (checkSummedToken1 === outputCurrencyId || checkSummedToken1 === outputCurrencyId);
        });
    }, [
        stableFarms,
        inputCurrencyId,
        outputCurrencyId
    ]);
    var currencies = (0,react.useMemo)(function() {
        var _obj;
        return _obj = {}, (0,_define_property/* default */.Z)(_obj, swap_actions/* Field.INPUT */.gN.INPUT, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined), (0,_define_property/* default */.Z)(_obj, swap_actions/* Field.OUTPUT */.gN.OUTPUT, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined), _obj;
    }, [
        inputCurrency,
        outputCurrency
    ]);
    var ref8 = (0,hooks/* useDerivedSwapInfo */.SM)(independentField, typedValue, inputCurrency, outputCurrency, recipient), v2Trade = ref8.v2Trade, currencyBalances = ref8.currencyBalances, parsedAmount = ref8.parsedAmount, swapInputError = ref8.inputError;
    var ref9 = useWrapCallback(currencies[swap_actions/* Field.INPUT */.gN.INPUT], currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT], typedValue), wrapType = ref9.wrapType, onWrap = ref9.execute, wrapInputError = ref9.inputError;
    var showWrap = wrapType !== WrapType.NOT_APPLICABLE;
    var trade = showWrap ? undefined : v2Trade;
    var _obj, _obj1;
    var parsedAmounts = showWrap ? (_obj = {}, (0,_define_property/* default */.Z)(_obj, swap_actions/* Field.INPUT */.gN.INPUT, parsedAmount), (0,_define_property/* default */.Z)(_obj, swap_actions/* Field.OUTPUT */.gN.OUTPUT, parsedAmount), _obj) : (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, swap_actions/* Field.INPUT */.gN.INPUT, independentField === swap_actions/* Field.INPUT */.gN.INPUT ? parsedAmount : trade === null || trade === void 0 ? void 0 : trade.inputAmount), (0,_define_property/* default */.Z)(_obj1, swap_actions/* Field.OUTPUT */.gN.OUTPUT, independentField === swap_actions/* Field.OUTPUT */.gN.OUTPUT ? parsedAmount : trade === null || trade === void 0 ? void 0 : trade.outputAmount), _obj1);
    var ref10 = (0,useSwapActionHandlers/* useSwapActionHandlers */._)(), onSwitchTokens = ref10.onSwitchTokens, onCurrencySelection = ref10.onCurrencySelection, onUserInput = ref10.onUserInput, onChangeRecipient = ref10.onChangeRecipient;
    var dependentField = independentField === swap_actions/* Field.INPUT */.gN.INPUT ? swap_actions/* Field.OUTPUT */.gN.OUTPUT : swap_actions/* Field.INPUT */.gN.INPUT;
    var handleTypeInput = (0,react.useCallback)(function(value) {
        onUserInput(swap_actions/* Field.INPUT */.gN.INPUT, value);
    }, [
        onUserInput
    ]);
    var handleTypeOutput = (0,react.useCallback)(function(value) {
        onUserInput(swap_actions/* Field.OUTPUT */.gN.OUTPUT, value);
    }, [
        onUserInput
    ]);
    var ref11, ref12;
    var _obj2;
    var formattedAmounts = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, independentField, typedValue), (0,_define_property/* default */.Z)(_obj2, dependentField, showWrap ? (ref11 = (ref = parsedAmounts[independentField]) === null || ref === void 0 ? void 0 : ref.toExact()) !== null && ref11 !== void 0 ? ref11 : "" : (ref12 = (ref1 = parsedAmounts[dependentField]) === null || ref1 === void 0 ? void 0 : ref1.toSignificant(6)) !== null && ref12 !== void 0 ? ref12 : ""), _obj2);
    // check whether the user has approved the router on the input token
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useApproveCallback/* useApproveCallbackFromTrade */.re)(trade, allowedSlippage, chainId), 2), approval = ref13[0], approveCallback = ref13[1];
    // check if user has gone through approval process, used to show two step buttons, reset on token change
    var ref14 = (0,react.useState)(false), approvalSubmitted = ref14[0], setApprovalSubmitted = ref14[1];
    // mark when a user has submitted an approval, reset onTokenSelection for input field
    (0,react.useEffect)(function() {
        if (approval === useApproveCallback/* ApprovalState.PENDING */.UK.PENDING) {
            setApprovalSubmitted(true);
        }
    }, [
        approval,
        approvalSubmitted
    ]);
    var maxAmountInput = (0,maxAmountSpend/* maxAmountSpend */.i)(currencyBalances[swap_actions/* Field.INPUT */.gN.INPUT]);
    var atMaxAmountInput = Boolean(maxAmountInput && ((ref2 = parsedAmounts[swap_actions/* Field.INPUT */.gN.INPUT]) === null || ref2 === void 0 ? void 0 : ref2.equalTo(maxAmountInput)));
    // errors
    var ref15 = (0,react.useState)(false), showInverted = ref15[0], setShowInverted = ref15[1];
    var handleInputSelect = (0,react.useCallback)(function(currencyInput) {
        setApprovalSubmitted(false) // reset 2 step UI for approvals
        ;
        onCurrencySelection(swap_actions/* Field.INPUT */.gN.INPUT, currencyInput);
        warningSwapHandler(currencyInput);
        (0,replaceBrowserHistory/* default */.Z)("inputCurrency", (0,currencyId/* currencyId */.H)(currencyInput));
    }, [
        onCurrencySelection,
        warningSwapHandler
    ]);
    var handleMaxInput = (0,react.useCallback)(function() {
        if (maxAmountInput) {
            onUserInput(swap_actions/* Field.INPUT */.gN.INPUT, maxAmountInput.toExact());
        }
    }, [
        maxAmountInput,
        onUserInput
    ]);
    var handleOutputSelect = (0,react.useCallback)(function(currencyOutput) {
        onCurrencySelection(swap_actions/* Field.OUTPUT */.gN.OUTPUT, currencyOutput);
        warningSwapHandler(currencyOutput);
        (0,replaceBrowserHistory/* default */.Z)("outputCurrency", (0,currencyId/* currencyId */.H)(currencyOutput));
    }, [
        onCurrencySelection,
        warningSwapHandler
    ]);
    var handlePercentInput = (0,react.useCallback)(function(percent) {
        if (maxAmountInput) {
            onUserInput(swap_actions/* Field.INPUT */.gN.INPUT, maxAmountInput.multiply(new src/* Percent */.gG(percent, 100)).toExact());
        }
    }, [
        maxAmountInput,
        onUserInput
    ]);
    var swapIsUnsupported = (0,Trades/* useIsTransactionUnsupported */.mP)(currencies === null || currencies === void 0 ? void 0 : currencies.INPUT, currencies === null || currencies === void 0 ? void 0 : currencies.OUTPUT);
    var hasAmount = Boolean(parsedAmount);
    var onRefreshPrice = (0,react.useCallback)(function() {
        if (hasAmount) {
            refreshBlockNumber();
        }
    }, [
        hasAmount,
        refreshBlockNumber
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                    gap: "sm",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerCurrency, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                label: independentField === swap_actions/* Field.OUTPUT */.gN.OUTPUT && !showWrap && trade ? t("From (estimated)") : t("From"),
                                value: formattedAmounts[swap_actions/* Field.INPUT */.gN.INPUT],
                                showMaxButton: !atMaxAmountInput,
                                showQuickInputButton: true,
                                currency: currencies[swap_actions/* Field.INPUT */.gN.INPUT],
                                onUserInput: handleTypeInput,
                                onPercentInput: handlePercentInput,
                                onMax: handleMaxInput,
                                onCurrencySelect: handleInputSelect,
                                otherCurrency: currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT],
                                id: "swap-currency-input",
                                showCommonBases: true,
                                commonBasesType: SearchModal_types/* CommonBasesType.SWAP_LIMITORDER */.L0.SWAP_LIMITORDER
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                            justify: "space-between",
                            style: {
                                paddingTop: "1rem",
                                paddingBottom: "1rem"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                justify: isExpertMode ? "space-between" : "center",
                                style: {
                                    padding: "0 1rem"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchIconButton, {
                                        variant: "light",
                                        scale: "sm",
                                        onClick: function() {
                                            setApprovalSubmitted(false) // reset 2 step UI for approvals
                                            ;
                                            onSwitchTokens();
                                            (0,replaceBrowserHistory/* default */.Z)("inputCurrency", outputCurrencyId);
                                            (0,replaceBrowserHistory/* default */.Z)("outputCurrency", inputCurrencyId);
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapIcon/* default */.Z, {
                                            width: "300px",
                                            height: "10px"
                                        })
                                    }),
                                    recipient === null && !showWrap && isExpertMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        variant: "text",
                                        id: "add-recipient-button",
                                        onClick: function() {
                                            return onChangeRecipient("");
                                        },
                                        children: t("+ Add a send (optional)")
                                    }) : null
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContainerCurrency, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyInputPanel/* default */.Z, {
                                value: formattedAmounts[swap_actions/* Field.OUTPUT */.gN.OUTPUT],
                                onUserInput: handleTypeOutput,
                                label: independentField === swap_actions/* Field.INPUT */.gN.INPUT && !showWrap && trade ? t("To (estimated)") : t("To"),
                                showMaxButton: false,
                                currency: currencies[swap_actions/* Field.OUTPUT */.gN.OUTPUT],
                                onCurrencySelect: handleOutputSelect,
                                otherCurrency: currencies[swap_actions/* Field.INPUT */.gN.INPUT],
                                id: "swap-currency-output",
                                showCommonBases: true,
                                commonBasesType: SearchModal_types/* CommonBasesType.SWAP_LIMITORDER */.L0.SWAP_LIMITORDER
                            })
                        }),
                        isExpertMode && recipient !== null && !showWrap ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* AutoRow */.BA, {
                                    justify: "space-between",
                                    style: {
                                        padding: "0 1rem"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowWrapper, {
                                            clickable: false,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                                                width: "16px"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "text",
                                            id: "remove-recipient-button",
                                            onClick: function() {
                                                return onChangeRecipient(null);
                                            },
                                            children: t("- Remove send")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInputPanel, {
                                    id: "recipient",
                                    value: recipient,
                                    onChange: onChangeRecipient
                                })
                            ]
                        }) : null,
                        showWrap ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
                            gap: "7px",
                            style: {
                                padding: "16px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowBetween */.m0, {
                                    align: "center",
                                    children: Boolean(trade) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                mr: "8px",
                                                children: t("Price")
                                            }),
                                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                                                width: "100%",
                                                ml: "8px",
                                                height: "24px"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TradePrice, {
                                                price: trade === null || trade === void 0 ? void 0 : trade.executionPrice,
                                                showInverted: showInverted,
                                                setShowInverted: setShowInverted
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                            children: t("Slippage tolerance")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            color: "text",
                                            children: [
                                                allowedSlippage / 100,
                                                "%"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                hasStableSwapAlternative && /*#__PURE__*/ (0,jsx_runtime.jsx)(Column/* AutoColumn */.Tz, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                        variant: "warning",
                        my: "16px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* MessageText */.Y, {
                            children: t("Trade stablecoins in StableSwap with lower slippage and trading fees!")
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CsBox, {
                    mt: "1rem",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CsSwapCommitButton, {
                        swapIsUnsupported: swapIsUnsupported,
                        account: account,
                        showWrap: showWrap,
                        wrapInputError: wrapInputError,
                        onWrap: onWrap,
                        wrapType: wrapType,
                        parsedIndepentFieldAmount: parsedAmounts[independentField],
                        approval: approval,
                        approveCallback: approveCallback,
                        approvalSubmitted: approvalSubmitted,
                        currencies: currencies,
                        isExpertMode: isExpertMode,
                        trade: trade,
                        swapInputError: swapInputError,
                        currencyBalances: currencyBalances,
                        recipient: recipient,
                        allowedSlippage: allowedSlippage,
                        onUserInput: onUserInput
                    })
                }),
                !swapIsUnsupported ? trade && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvancedSwapDetailsDropdown, {
                    trade: trade
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UnsupportedCurrencyFooter/* default */.Z, {
                    currencies: [
                        currencies.INPUT,
                        currencies.OUTPUT
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./src/views/Swap/styles.tsx

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-shrink: 0;\n  height: fit-content;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var StyledSwapContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-1bce00df-0"
})(styles_templateObject());
var StyledInputCurrencyWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-1bce00df-1"
})(styles_templateObject1());

// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowBack.tsx
var ArrowBack = __webpack_require__(47720);
// EXTERNAL MODULE: ./packages/uikit/src/components/NotificationDot/NotificationDot.tsx
var NotificationDot = __webpack_require__(17084);
// EXTERNAL MODULE: ./src/components/Menu/GlobalSettings/index.tsx
var GlobalSettings = __webpack_require__(69425);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/App/Transactions/index.tsx + 2 modules
var Transactions = __webpack_require__(26364);
;// CONCATENATED MODULE: ./src/views/Swap/components/AppHeader.tsx


function AppHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"
    ]);
    AppHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AppHeader_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n font-size:48px;\n text-align:center;\n @media (max-width:600px){\n  font-size:36px;\n}\n"
    ]);
    AppHeader_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AppHeader_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n @media(max-width:600px){\n   flex-direction:column;\n }\n\n"
    ]);
    AppHeader_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var AppHeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-9ddc4caf-0"
})(AppHeader_templateObject());
var AppHeader = function(param) {
    var title = param.title, subtitle = param.subtitle, helper = param.helper, backTo = param.backTo, _noConfig = param.noConfig, noConfig = _noConfig === void 0 ? false : _noConfig;
    var ref = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useExpertModeManager */.DG)(), 1), expertMode = ref[0];
    var theme = (0,useTheme/* default */.ZP)().theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppHeaderContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
            alignItems: "center",
            width: "100%",
            style: {
                gap: "16px"
            },
            children: [
                backTo && (typeof backTo === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    passHref: true,
                    href: backTo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        as: "a",
                        scale: "sm",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                            width: "32px"
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    scale: "sm",
                    variant: "text",
                    onClick: backTo,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                        width: "32px"
                    })
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    flexDirection: "column",
                    width: "100%",
                    children: [
                        !noConfig && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            width: "100%",
                            justifyContent: "flex-end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NotificationDot/* default */.Z, {
                                    show: expertMode,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalSettings/* default */.Z, {
                                        mode: GlobalSettings_types/* SettingsMode.SWAP_LIQUIDITY */.a.SWAP_LIQUIDITY,
                                        color: theme.colors.text
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Transactions/* default */.Z, {
                                    iconColors: "text"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CsTextHeader, {
                            as: "h2",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppHeader_CsFlex, {
                            mb: "16px",
                            mt: "8px",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    alignItems: "center",
                                    width: "100%",
                                    justifyContent: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: "text",
                                        fontSize: "16px",
                                        children: subtitle
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    children: helper && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuestionHelper/* default */.Z, {
                                        text: helper,
                                        ml: "4px",
                                        placement: "top-start"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var CsTextHeader = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-9ddc4caf-1"
})(AppHeader_templateObject1());
var AppHeader_CsFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-9ddc4caf-2"
})(AppHeader_templateObject2());
/* harmony default export */ var components_AppHeader = (AppHeader);

;// CONCATENATED MODULE: ./src/views/Swap/index.tsx



function Swap_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  @media only screen and (max-width: 768px) {\n      margin-bottom:30px;\n  }\n"
    ]);
    Swap_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Swap_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 20px 0;\n"
    ]);
    Swap_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Swap_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0 5px;\n"
    ]);
    Swap_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Swap_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-around;\n  padding-left: 20px;\n"
    ]);
    Swap_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Swap_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  max-width: 600px;\n  width: 100%;\n  z-index: 5;\n  border-radius: 20px;\n  margin-bottom: 30px;\n  @media only screen and (max-width: 600px) {\n    width: 100%;\n    padding: 0px;\n  }\n"
    ]);
    Swap_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



















// eslint-disable-next-line import/named

var CHART_SUPPORT_CHAIN_IDS = [
    src/* ChainId.BSC */.a_.BSC
];
var ACCESS_TOKEN_SUPPORT_CHAIN_IDS = [
    src/* ChainId.BSC */.a_.BSC
];
var STABLE_SUPPORT_CHAIN_IDS = [
    src/* ChainId.BSC_TESTNET */.a_.BSC_TESTNET,
    src/* ChainId.BSC */.a_.BSC
];
function Swap() {
    var isMobile = (0,useMatchBreakpoints/* default */.Z)().isMobile;
    var ref = (0,react.useState)(false), isChartExpanded = ref[0], setIsChartExpanded = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,user_hooks/* useExchangeChartManager */.vD)(isMobile), 2), userChartPreference = ref1[0], setUserChartPreference = ref1[1];
    var ref2 = (0,react.useState)(userChartPreference), isChartDisplayed = ref2[0], setIsChartDisplayed = ref2[1];
    useDefaultsFromURLSearch();
    (0,react.useEffect)(function() {
        setUserChartPreference(isChartDisplayed);
    }, [
        isChartDisplayed,
        setUserChartPreference
    ]);
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    // swap state & price data
    var ref3 = (0,hooks/* useSwapState */.dU)(), _INPUT = ref3[swap_actions/* Field.INPUT */.gN.INPUT], inputCurrencyId = _INPUT.currencyId, _OUTPUT = ref3[swap_actions/* Field.OUTPUT */.gN.OUTPUT], outputCurrencyId = _OUTPUT.currencyId;
    var inputCurrency = (0,Tokens/* useCurrency */.U8)(inputCurrencyId);
    var outputCurrency = (0,Tokens/* useCurrency */.U8)(outputCurrencyId);
    var _obj;
    var currencies = (_obj = {}, (0,_define_property/* default */.Z)(_obj, swap_actions/* Field.INPUT */.gN.INPUT, inputCurrency !== null && inputCurrency !== void 0 ? inputCurrency : undefined), (0,_define_property/* default */.Z)(_obj, swap_actions/* Field.OUTPUT */.gN.OUTPUT, outputCurrency !== null && outputCurrency !== void 0 ? outputCurrency : undefined), _obj);
    var singleTokenPrice = (0,hooks/* useSingleTokenSwapInfo */.yF)(inputCurrencyId, inputCurrency, outputCurrencyId, outputCurrency);
    var isChartSupported = (0,react.useMemo)(function() {
        return(// avoid layout shift, by default showing
        !chainId || CHART_SUPPORT_CHAIN_IDS.includes(chainId));
    }, [
        chainId
    ]);
    var isStableSupported = (0,react.useMemo)(function() {
        return !chainId || STABLE_SUPPORT_CHAIN_IDS.includes(chainId);
    }, [
        chainId
    ]);
    var isAccessTokenSupported = (0,react.useMemo)(function() {
        return ACCESS_TOKEN_SUPPORT_CHAIN_IDS.includes(chainId);
    }, [
        chainId
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageFullWidth/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNav/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WrapAppBody, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styleds_Wrapper, {
                        id: "swap-page",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AppHeader, {
                                title: t("Swap"),
                                subtitle: t("Swap tokens easily with one click")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                width: "100%",
                                justifyContent: "center",
                                position: "relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    flexDirection: "column",
                                    width: "100%",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSwapContainer, {
                                            $isChartExpanded: isChartExpanded,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInputCurrencyWrapper, {
                                                mt: isChartExpanded ? "24px" : "0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapForm, {
                                                    isAccessTokenSupported: isAccessTokenSupported,
                                                    setIsChartDisplayed: setIsChartDisplayed,
                                                    isChartDisplayed: isChartDisplayed
                                                })
                                            })
                                        }),
                                        isChartExpanded && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                            display: [
                                                "none",
                                                null,
                                                null,
                                                "block"
                                            ],
                                            width: "100%",
                                            height: "100%",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                                                variant: "side",
                                                helpUrl: constants/* EXCHANGE_DOCS_URLS */.SO
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fa3c7d29-0"
})(Swap_templateObject());
var CustomToken = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-fa3c7d29-1"
})(Swap_templateObject1());
var WrapIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fa3c7d29-2"
})(Swap_templateObject2());
var CustomFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-fa3c7d29-3"
})(Swap_templateObject3());
var WrapAppBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-fa3c7d29-4"
})(Swap_templateObject4());

;// CONCATENATED MODULE: ./src/pages/swap.tsx



var SwapPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Swap, {});
};
SwapPage.chains = supportChains/* SUPPORT_BSC */.Xz;
/* harmony default export */ var swap = (SwapPage);


/***/ }),

/***/ 11372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ maxAmountSpend; }
/* harmony export */ });
/* harmony import */ var _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1505);
/* harmony import */ var config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56974);


/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */ function maxAmountSpend(currencyAmount) {
    var ref;
    if (!currencyAmount) return undefined;
    if ((ref = currencyAmount.currency) === null || ref === void 0 ? void 0 : ref.isNative) {
        if (_pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.greaterThan */ .QA.greaterThan(currencyAmount.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz)) {
            return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyAmount.currency, _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .JSBI.subtract */ .QA.subtract(currencyAmount.quotient, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .MIN_BNB */ .Uz));
        }
        return _pancakeswap_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CurrencyAmount.fromRawAmount */ .ih.fromRawAmount(currencyAmount.currency, config_constants_exchange__WEBPACK_IMPORTED_MODULE_1__/* .BIG_INT_ZERO */ .iV);
    }
    return currencyAmount;
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8388,1372,2800,202,5855,921,4466,3690,8847,9272,5492,9774,2888,179], function() { return __webpack_exec__(98229); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);